/**
 * Modular Verra Closet Configurator
 * Version: 1.0.1
 * Build: 5
 * Last Commit: 83de5cf
 * Build Date: 2025-09-01
 *
 * This file was automatically generated.
 * Do not edit the version header manually.
 */

import * as THREE from "three";
//comment
export const positions = {
  //   "16W_TOWER": [new THREE.Vector3(0, 0, 0)],
  "16.5/16.5W_TOWER": [new THREE.Vector3(0, 0, 0)],
  "18/18W_TOWER": [new THREE.Vector3(0, 0, 0)],
  "19.5/19.5W_TOWER": [new THREE.Vector3(0, 0, 0)],
  "21/21W_TOWER": [new THREE.Vector3(0, 0, 0)],
  "22.5/22.5W_TOWER": [new THREE.Vector3(0, 0, 0)],
  "24/24W_TOWER": [new THREE.Vector3(0, 0, 0)],
  "25.5/25.5W_TOWER": [new THREE.Vector3(0, 0, 0)],
  "27/27W_TOWER": [new THREE.Vector3(0, 0, 0)],
  "28.5/28.5W_TOWER": [new THREE.Vector3(0, 0, 0)],
  "30/30W_TOWER": [new THREE.Vector3(0, 0, 0)],
  "31.5/31.5W_TOWER": [new THREE.Vector3(0, 0, 0)],
  "33/33W_TOWER": [new THREE.Vector3(0, 0, 0)],
  "34.5/34.5W_TOWER": [new THREE.Vector3(0, 0, 0)],
  "36/36W_TOWER": [new THREE.Vector3(0, 0, 0)],

  top: [
    {
      name: "_rod_1",
      position: [new THREE.Vector3(0, 1.85, 0)],
    },
    {
      name: "_rod",
      position: [new THREE.Vector3(0, 1.9, 0)],
    },
    {
      name: "_shelf_dp14_1",
      position: [new THREE.Vector3(0, 1.4, 0)],
    },
    {
      name: "_shelf_dp14_2",
      position: [new THREE.Vector3(0, 1.75, 0)],
    },
    {
      name: "_shelf_dp14_3",
      position: [new THREE.Vector3(0, 1.92, 0)],
    },
    {
      name: "_shelf_1",
      position: [new THREE.Vector3(0, 1.4, 0)],
    },
    {
      name: "_shelf_2",
      position: [new THREE.Vector3(0, 1.75, 0)],
    },
    {
      name: "_shelf_3",
      position: [new THREE.Vector3(0, 1.92, 0)],
    },
    {
      name: "_shelf_middle",
      position: [new THREE.Vector3(0, 1.05, 0)],
    },
    {
      name: "_shelf",
      position: [new THREE.Vector3(0, 1.4, 0)],
    },

    {
      name: "_cubby",
      position: [new THREE.Vector3(0, 1.065, 0)],
    },
    {
      name: "_dr_1",
      position: [new THREE.Vector3(0, 2.15, 0)],
    },
    {
      name: "_dr_2",
      position: [new THREE.Vector3(0, 2.405, 0)],
    },
    {
      name: "_dr_3",
      position: [new THREE.Vector3(0, 2.66, 0)],
    },
    {
      name: "_dr_4",
      position: [new THREE.Vector3(0, 2.915, 0)],
    },
    {
      name: "_dr",
      position: [new THREE.Vector3(0, 2.2, 0)],
    },
    {
      name: "_ss_1",
      position: [new THREE.Vector3(0, 1.6, 0)],
    },
    {
      name: "_ss_2",
      position: [new THREE.Vector3(0, 1.85, 0)],
    },
    {
      name: "_ss_3",
      position: [new THREE.Vector3(0, 2.1, 0)],
    },
    {
      name: "_ss_4",
      position: [new THREE.Vector3(0, 2.35, 0)],
    },
    {
      name: "_ss_dp14_1",
      position: [new THREE.Vector3(0, 1.6, 0)],
    },
    {
      name: "_ss_dp14_2",
      position: [new THREE.Vector3(0, 1.85, 0)],
    },
    {
      name: "_ss_dp14_3",
      position: [new THREE.Vector3(0, 2.1, 0)],
    },
    {
      name: "_ss_dp14_4",
      position: [new THREE.Vector3(0, 2.35, 0)],
    },

    {
      name: "_ss",
      position: [new THREE.Vector3(0, 1.8, 0)],
    },
    {
      name: "_fhd_l",
      position: [new THREE.Vector3(0, 1.05, 0)],
    },
    {
      name: "_fhd_r",
      position: [new THREE.Vector3(0, 1.05, 0)],
    },
    {
      name: "_hdo_l",
      position: [new THREE.Vector3(0, 1.05, 0)],
    },
    {
      name: "_hdo_r",
      position: [new THREE.Vector3(0, 1.05, 0)],
    },
    {
      name: "_hdp_l",
      position: [new THREE.Vector3(0, 1.05, 0)],
    },
    {
      name: "_hdp_r",
      position: [new THREE.Vector3(0, 1.05, 0)],
    },
  ],
  bottom: [
    {
      name: "_rod",
      position: [new THREE.Vector3(0, 0.9, 0)],
    },
    {
      name: "_shelf_dp14_1",
      position: [new THREE.Vector3(0, 0.35, 0)],
    },
    {
      name: "_shelf_dp14_2",
      position: [new THREE.Vector3(0, 0.7, 0)],
    },
    {
      name: "_shelf_1",
      position: [new THREE.Vector3(0, 0.35, 0)],
    },
    {
      name: "_shelf_2",
      position: [new THREE.Vector3(0, 0.7, 0)],
    },
    {
      name: "_shelf",
      position: [new THREE.Vector3(0, 0.5, 0)],
    },
    {
      name: "_cubby",
      position: [new THREE.Vector3(0, 0.04, 0)],
    },
    {
      name: "_dr_s_1",
      position: [new THREE.Vector3(0, 1.825, 0)],
    },
    {
      name: "_dr_s_2",
      position: [new THREE.Vector3(0, 1.96, 0)],
    },
    {
      name: "_dr_1",
      position: [new THREE.Vector3(0, 1.1, 0)],
    },
    {
      name: "_dr_2",
      position: [new THREE.Vector3(0, 1.355, 0)],
    },
    {
      name: "_dr_3",
      position: [new THREE.Vector3(0, 1.61, 0)],
    },
    {
      name: "_dr_4",
      position: [new THREE.Vector3(0, 1.87, 0)],
    },
    {
      name: "_dr",
      position: [new THREE.Vector3(0, 1.1, 0)],
    },
    {
      name: "_ss_1",
      position: [new THREE.Vector3(0, 0.6, 0)],
    },
    {
      name: "_ss_2",
      position: [new THREE.Vector3(0, 0.85, 0)],
    },
    {
      name: "_ss_3",
      position: [new THREE.Vector3(0, 1.1, 0)],
    },
    {
      name: "_ss_4",
      position: [new THREE.Vector3(0, 1.35, 0)],
    },
    {
      name: "_ss_dp14_1",
      position: [new THREE.Vector3(0, 0.6, 0)],
    },
    {
      name: "_ss_dp14_2",
      position: [new THREE.Vector3(0, 0.85, 0)],
    },
    {
      name: "_ss_dp14_3",
      position: [new THREE.Vector3(0, 1.1, 0)],
    },
    {
      name: "_ss_dp14_4",
      position: [new THREE.Vector3(0, 1.35, 0)],
    },
    {
      name: "_ss",
      position: [new THREE.Vector3(0, 0.9, 0)],
    },
    {
      name: "_fhd_l",
      position: [new THREE.Vector3(0, 0.525, 0)],
    },
    {
      name: "_fhd_r",
      position: [new THREE.Vector3(0, 0.525, 0)],
    },
    {
      name: "_hdo_l",
      position: [new THREE.Vector3(0, 0.525, 0)],
    },
    {
      name: "_hdo_r",
      position: [new THREE.Vector3(0, 0.525, 0)],
    },
    {
      name: "_hdp_l",
      position: [new THREE.Vector3(0, 0.525, 0)],
    },
    {
      name: "_hdp_r",
      position: [new THREE.Vector3(0, 0.525, 0)],
    },
  ],
  door: [
    {
      name: "_fdo",
      position: [new THREE.Vector3(0, 0, 0)],
    },
    {
      name: "_3qd",
      position: [new THREE.Vector3(0, 0, 0)],
    },
    {
      name: "_hdo",
      position: [new THREE.Vector3(0, 0, 0)],
    },
    {
      name: "_fhd",
      position: [new THREE.Vector3(0, 0, 0)],
    },
    {
      name: "_fhd_l",
      position: [new THREE.Vector3(0, 1.05, 0)],
    },
    {
      name: "_fhd_r",
      position: [new THREE.Vector3(0, 1.05, 0)],
    },
    {
      name: "_hdo_l",
      position: [new THREE.Vector3(0, 1.05, 0)],
    },
    {
      name: "_hdo_r",
      position: [new THREE.Vector3(0, 1.05, 0)],
    },
    {
      name: "_hdp_l",
      position: [new THREE.Vector3(0, 1.05, 0)],
    },
    {
      name: "_hdp_r",
      position: [new THREE.Vector3(0, 1.05, 0)],
    },
  ],

  doorHardware: [
    {
      name: "pull_modern_l",
      position: [new THREE.Vector3(-0.05, 1.05, 0.324)],
      rotation: [new THREE.Euler(0, Math.PI / 2, -Math.PI / 2)],
    },
    {
      name: "pull_modern_l",
      extraName: "top",
      position: [new THREE.Vector3(-0.05, 1.275, 0.324)],
      rotation: [new THREE.Euler(0, Math.PI / 2, -Math.PI / 2)],
    },
    {
      name: "pull_modern_r",
      position: [new THREE.Vector3(0.05, 1.05, 0.324)],
      rotation: [new THREE.Euler(0, Math.PI / 2, -Math.PI / 2)],
    },
    {
      name: "pull_modern_r",
      extraName: "top",
      position: [new THREE.Vector3(0.05, 1.275, 0.324)],
      rotation: [new THREE.Euler(0, Math.PI / 2, -Math.PI / 2)],
    },

    {
      name: "pull_modern_s",
      position: [new THREE.Vector3(0, 1.05, 0.324)],
      rotation: [new THREE.Euler(0, Math.PI / 2, -Math.PI / 2)],
    },
    {
      name: "pull_modern_s",
      extraName: "top",
      position: [new THREE.Vector3(0, 1.275, 0.324)],
      rotation: [new THREE.Euler(0, Math.PI / 2, -Math.PI / 2)],
    },
    {
      name: "pull_knob_l",
      position: [new THREE.Vector3(-0.05, 1.0, 0.3)],
      rotation: [new THREE.Euler(Math.PI / 2, 0, 0)],
    },
    {
      name: "pull_knob_l",
      extraName: "top",
      position: [new THREE.Vector3(-0.05, 1.2, 0.3)],
      rotation: [new THREE.Euler(Math.PI / 2, 0, 0)],
    },
    {
      name: "pull_knob_r",
      position: [new THREE.Vector3(0.05, 1.0, 0.3)],
      rotation: [new THREE.Euler(Math.PI / 2, 0, 0)],
    },
    {
      name: "pull_knob_r",
      extraName: "top",
      position: [new THREE.Vector3(0.05, 1.2, 0.3)],
      rotation: [new THREE.Euler(Math.PI / 2, 0, 0)],
    },
    {
      name: "pull_knob_s",
      position: [new THREE.Vector3(0, 1.0, 0.3)],
      rotation: [new THREE.Euler(Math.PI / 2, 0, 0)],
    },
    {
      name: "pull_knob_s",
      extraName: "top",
      position: [new THREE.Vector3(0, 1.2, 0.3)],
      rotation: [new THREE.Euler(Math.PI / 2, 0, 0)],
    },
  ],
  drawerHardware: [
    {
      name: "pull_modern_dr_m",
      extraName: "top1",
      position: [new THREE.Vector3(-0.07, 1.94, 0.324)],
      rotation: [new THREE.Euler(-Math.PI / 2, 0, 0)],
    },
    {
      name: "pull_modern_dr_m",
      extraName: "top2",
      position: [new THREE.Vector3(-0.07, 2.065, 0.324)],
      rotation: [new THREE.Euler(-Math.PI / 2, 0, 0)],
    },
    {
      name: "pull_modern_dr",
      extraName: "top1",
      position: [new THREE.Vector3(-0.07, 1.24, 0.324)],
      rotation: [new THREE.Euler(-Math.PI / 2, 0, 0)],
    },
    {
      name: "pull_modern_dr",
      extraName: "top2",
      position: [new THREE.Vector3(-0.07, 1.495, 0.324)],
      rotation: [new THREE.Euler(-Math.PI / 2, 0, 0)],
    },
    {
      name: "pull_modern_dr",
      extraName: "top3",
      position: [new THREE.Vector3(-0.07, 1.75, 0.324)],
      rotation: [new THREE.Euler(-Math.PI / 2, 0, 0)],
    },
    {
      name: "pull_modern_dr",
      extraName: "top4",
      position: [new THREE.Vector3(-0.07, 2.0, 0.324)],
      rotation: [new THREE.Euler(-Math.PI / 2, 0, 0)],
    },
    {
      name: "pull_modern_dr_m",
      extraName: "bottom1",
      position: [new THREE.Vector3(-0.07, 0.9, 0.324)],
      rotation: [new THREE.Euler(-Math.PI / 2, 0, 0)],
    },
    {
      name: "pull_modern_dr_m",
      extraName: "bottom2",
      position: [new THREE.Vector3(-0.07, 1.025, 0.324)],
      rotation: [new THREE.Euler(-Math.PI / 2, 0, 0)],
    },
    {
      name: "pull_modern_dr",
      extraName: "bottom1",
      position: [new THREE.Vector3(-0.07, 0.185, 0.324)],
      rotation: [new THREE.Euler(-Math.PI / 2, 0, 0)],
    },
    {
      name: "pull_modern_dr",
      extraName: "bottom2",
      position: [new THREE.Vector3(-0.07, 0.45, 0.324)],
      rotation: [new THREE.Euler(-Math.PI / 2, 0, 0)],
    },
    {
      name: "pull_modern_dr",
      extraName: "bottom3",
      position: [new THREE.Vector3(-0.07, 0.7, 0.324)],
      rotation: [new THREE.Euler(-Math.PI / 2, 0, 0)],
    },
    {
      name: "pull_modern_dr",
      extraName: "bottom4",
      position: [new THREE.Vector3(-0.07, 0.95, 0.324)],
      rotation: [new THREE.Euler(-Math.PI / 2, 0, 0)],
    },
    {
      name: "pull_knob_dr_m",
      extraName: "top1",
      position: [new THREE.Vector3(0, 1.94, 0.324)],
      rotation: [new THREE.Euler(Math.PI / 2, Math.PI / 2, 0)],
    },
    {
      name: "pull_knob_dr_m",
      extraName: "top2",
      position: [new THREE.Vector3(0, 2.065, 0.324)],
      rotation: [new THREE.Euler(Math.PI / 2, Math.PI / 2, 0)],
    },
    {
      name: "pull_knob_dr",
      extraName: "top1",
      position: [new THREE.Vector3(0, 1.24, 0.324)],
      rotation: [new THREE.Euler(Math.PI / 2, Math.PI / 2, 0)],
    },
    {
      name: "pull_knob_dr",
      extraName: "top2",
      position: [new THREE.Vector3(0, 1.495, 0.324)],
      rotation: [new THREE.Euler(Math.PI / 2, Math.PI / 2, 0)],
    },
    {
      name: "pull_knob_dr",
      extraName: "top3",
      position: [new THREE.Vector3(0, 1.75, 0.324)],
      rotation: [new THREE.Euler(Math.PI / 2, Math.PI / 2, 0)],
    },
    {
      name: "pull_knob_dr",
      extraName: "top4",
      position: [new THREE.Vector3(0, 1.995, 0.324)],
      rotation: [new THREE.Euler(Math.PI / 2, Math.PI / 2, 0)],
    },
    {
      name: "pull_knob_dr_m",
      extraName: "bottom1",
      position: [new THREE.Vector3(0, 0.9, 0.324)],
      rotation: [new THREE.Euler(Math.PI / 2, Math.PI / 2, 0)],
    },
    {
      name: "pull_knob_dr_m",
      extraName: "bottom2",
      position: [new THREE.Vector3(0, 1.025, 0.324)],
      rotation: [new THREE.Euler(Math.PI / 2, Math.PI / 2, 0)],
    },
    {
      name: "pull_knob_dr",
      extraName: "bottom1",
      position: [new THREE.Vector3(0, 0.185, 0.324)],
      rotation: [new THREE.Euler(Math.PI / 2, Math.PI / 2, 0)],
    },
    {
      name: "pull_knob_dr",
      extraName: "bottom2",
      position: [new THREE.Vector3(0, 0.45, 0.324)],
      rotation: [new THREE.Euler(Math.PI / 2, Math.PI / 2, 0)],
    },
    {
      name: "pull_knob_dr",
      extraName: "bottom3",
      position: [new THREE.Vector3(0, 0.7, 0.324)],
      rotation: [new THREE.Euler(Math.PI / 2, Math.PI / 2, 0)],
    },
    {
      name: "pull_knob_dr",
      extraName: "bottom4",
      position: [new THREE.Vector3(0, 0.95, 0.324)],
      rotation: [new THREE.Euler(Math.PI / 2, Math.PI / 2, 0)],
    },
  ],
  // Wardrobe_D22_W30: [new THREE.Vector3(0, 0, 0)],
  // Wardrobe_D22_W15: [new THREE.Vector3(0, 0, 0)],
  // Wardrobe_D22_ND_W30: [new THREE.Vector3(0, 0, 0)],
  // Wardrobe_D22_ND_W15: [new THREE.Vector3(0, 0, 0)],

  // Chest_of_Drawers: [new THREE.Vector3(0, 0.379, 0)],
  // Chest_of_Drawers_Separate: [new THREE.Vector3(0, 0.379, 0)],

  // Chest_of_Drawers_W15: [new THREE.Vector3(0, 0.379, 0)],
  // Chest_of_Drawers_Separate_W15: [new THREE.Vector3(0, 0.379, 0)],

  // Cubby_Over_Chest: [new THREE.Vector3(0, 0.878, 0)],

  // Cubby_Over_Chest_W15: [new THREE.Vector3(0, 0.878, 0)],

  // Hanger_W30: [
  //   new THREE.Vector3(0, 1.986, 0),
  //   new THREE.Vector3(0, 0.953, 0),
  //   // new THREE.Vector3(0, 1.835, 0),
  //   new THREE.Vector3(0, 1.735, 0),
  // ],
  // Hanger_W15: [
  //   new THREE.Vector3(0, 1.986, 0),
  //   new THREE.Vector3(0, 0.953, 0),
  //   // new THREE.Vector3(0, 1.835, 0),
  //   new THREE.Vector3(0, 1.735, 0),
  // ],

  // Cubby_Shelves_D22_W30: [new THREE.Vector3(0, 1.623, -0.008)],
  // Cubby_Shelves_D22_W15: [new THREE.Vector3(0, 1.623, -0.008)],

  // Two_Drawers_D22_W30: [
  //   new THREE.Vector3(0, 0.323, 0.259),
  //   new THREE.Vector3(0, 0.84, 0.259),
  // ],
  // Two_Drawers_D22_W15: [
  //   new THREE.Vector3(0, 0.323, 0.259),
  //   new THREE.Vector3(0, 0.84, 0.259),
  // ],

  // One_Flat_Door_Left: [new THREE.Vector3(-0.3892, 1.094, 0.279)],
  // One_Flat_Door_Right: [new THREE.Vector3(0.3892, 1.094, 0.279)],

  // One_Flat_Door_W15: [new THREE.Vector3(0.196, 1.094, 0.279)],
  // One_Shaker_Door_W15: [new THREE.Vector3(0.196, 1.094, 0.279)],

  // One_Mirror_Door_Left: [new THREE.Vector3(-0.3892, 1.094, 0.279)],
  // One_Mirror_Door_Right: [new THREE.Vector3(0.3892, 1.094, 0.279)],

  // One_Mirror_Door_W15: [new THREE.Vector3(0.196, 1.094, 0.279)],

  // One_Shaker_Door_Left: [new THREE.Vector3(-0.3892, 1.094, 0.279)],
  // One_Shaker_Door_Right: [new THREE.Vector3(0.3892, 1.094, 0.279)],

  // One_Adjustable_Shelves_D22_W30: [
  //   new THREE.Vector3(0, 0.369, 0),
  //   new THREE.Vector3(0, 0.724, 0),
  //   new THREE.Vector3(0, 1.453, 0),
  //   new THREE.Vector3(0, 1.791, 0),
  //   // new THREE.Vector3(0, 1.926, 0),
  //   new THREE.Vector3(0, 1.835, 0),
  //   new THREE.Vector3(-0.002, 1.095, 0),
  // ],
  // One_Adjustable_Shelves_D22_W15: [
  //   new THREE.Vector3(0, 0.369, 0),
  //   new THREE.Vector3(0, 0.724, 0),
  //   new THREE.Vector3(0, 1.453, 0),
  //   new THREE.Vector3(0, 1.791, 0),
  //   // new THREE.Vector3(0, 1.926, 0),
  //   new THREE.Vector3(0, 1.835, 0),
  //   new THREE.Vector3(-0.002, 1.095, 0),
  // ],

  // Two_Shoe_Shelves_D22_W30: [new THREE.Vector3(0, 0.599, 0)],
  // One_Shoe_Shelves_D22_W15: [new THREE.Vector3(0, 0.599, 0)],

  // LeftHandle_W30: [new THREE.Vector3(-0.0125, 1.087, 0.285)],
  // RightHandle_W30: [new THREE.Vector3(0.0125, 1.087, 0.285)],

  // Handle_W15: [new THREE.Vector3(-0.139, 1.087, 0.285)],

  // Mirror_Door_Handle_R: [new THREE.Vector3(0.0125, 1.063, 0.285)],
  // Mirror_Door_Handle_L: [new THREE.Vector3(-0.0125, 1.125, 0.285)],
  // // Mirror_Door_Handle_W15: [new THREE.Vector3(-0.139, 1.09, 0.285)]
  // Mirror_Door_Handle_W15: [new THREE.Vector3(-0.19, 1.09, 0.285)],
};

export const SpaceId = {
  WARDROBE: "Wardrobe",
  LEFTDOOR: "LeftDoor",
  RIGHTDOOR: "RightDoor",
  SEVEN: "TopThree",
  SIX: "TopTwo",
  FIVE: "TopOne",
  FOUR: "TopZero",

  MIDDLE: "Middle",
  LEFTHANDLE: "LeftHandle",
  RIGHTHANDLE: "RightHandle",

  THREE: "BottomThree",
  TWO: "BottomTwo",
  ONE: "BottomOne",
  ZERO: "BottomZero",
};

export const occupiedSpaces = {
  [SpaceId.WARDROBE]: [],
  [SpaceId.MIDDLE]: [],
  [SpaceId.LEFTHANDLE]: [],
  [SpaceId.RIGHTHANDLE]: [],
  [SpaceId.LEFTDOOR]: [],
  [SpaceId.RIGHTDOOR]: [],

  [SpaceId.SEVEN]: [],
  [SpaceId.SIX]: [],
  [SpaceId.FIVE]: [],
  [SpaceId.FOUR]: [],
  [SpaceId.THREE]: [],
  [SpaceId.TWO]: [],
  [SpaceId.ONE]: [],
  [SpaceId.ZERO]: [],
};

export const SpaceOccupation = {
  "16.5/16.5W_TOWER": [[SpaceId.WARDROBE]],
  "18/18W_TOWER": [[SpaceId.WARDROBE]],
  "19.5/19.5W_TOWER": [[SpaceId.WARDROBE]],
  "21/21W_TOWER": [[SpaceId.WARDROBE]],
  "22.5/22.5W_TOWER": [[SpaceId.WARDROBE]],
  "24/24W_TOWER": [[SpaceId.WARDROBE]],
  "25.5/25.5W_TOWER": [[SpaceId.WARDROBE]],
  "27/27W_TOWER": [[SpaceId.WARDROBE]],
  "28.5/28.5W_TOWER": [[SpaceId.WARDROBE]],
  "30/30W_TOWER": [[SpaceId.WARDROBE]],
  "31.5/31.5W_TOWER": [[SpaceId.WARDROBE]],
  "33/33W_TOWER": [[SpaceId.WARDROBE]],
  "34.5/34.5W_TOWER": [[SpaceId.WARDROBE]],
  "36/36W_TOWER": [[SpaceId.WARDROBE]],

  Wardrobe_D22_W30: [[SpaceId.WARDROBE]],
  Wardrobe_D22_W15: [[SpaceId.WARDROBE]],
  Wardrobe_D22_ND_W30: [[SpaceId.WARDROBE]],
  Wardrobe_D22_ND_W15: [[SpaceId.WARDROBE]],

  Chest_of_Drawers: [[SpaceId.ZERO, SpaceId.ONE, SpaceId.TWO]],
  Chest_of_Drawers_Separate: [[SpaceId.ZERO, SpaceId.ONE, SpaceId.TWO]],
  Chest_of_Drawers_W15: [[SpaceId.ZERO, SpaceId.ONE, SpaceId.TWO]],
  Chest_of_Drawers_Separate_W15: [[SpaceId.ZERO, SpaceId.ONE, SpaceId.TWO]],

  Cubby_Over_Chest: [[SpaceId.THREE]],
  Cubby_Over_Chest_W15: [[SpaceId.THREE]],

  Cubby_Shelves_D22_W30: [
    [SpaceId.FOUR, SpaceId.FIVE, SpaceId.SIX, SpaceId.SEVEN],
  ],
  Cubby_Shelves_D22_W15: [
    [SpaceId.FOUR, SpaceId.FIVE, SpaceId.SIX, SpaceId.SEVEN],
  ],

  Two_Drawers_D22_W30: [
    [SpaceId.ZERO, SpaceId.ONE],
    [SpaceId.TWO, SpaceId.THREE],
  ],
  Two_Drawers_D22_W15: [
    [SpaceId.ZERO, SpaceId.ONE],
    [SpaceId.TWO, SpaceId.THREE],
  ],

  One_Adjustable_Shelves_D22_W30: [
    [SpaceId.ZERO, SpaceId.ONE],
    [SpaceId.TWO, SpaceId.THREE],
    [SpaceId.FOUR, SpaceId.FIVE],
    [SpaceId.SIX, SpaceId.SEVEN],
    [SpaceId.SEVEN],
    [SpaceId.MIDDLE],
  ],
  One_Adjustable_Shelves_D22_W15: [
    [SpaceId.ZERO, SpaceId.ONE],
    [SpaceId.TWO, SpaceId.THREE],
    [SpaceId.FOUR, SpaceId.FIVE],
    [SpaceId.SIX, SpaceId.SEVEN],
    [SpaceId.SEVEN],
    [SpaceId.MIDDLE],
  ],

  Two_Shoe_Shelves_D22_W30: [
    [SpaceId.ZERO, SpaceId.ONE, SpaceId.TWO, SpaceId.THREE],
  ],
  Two_Shoe_Shelves_D22_W15: [
    [SpaceId.ZERO, SpaceId.ONE, SpaceId.TWO, SpaceId.THREE],
  ],

  One_Flat_Door_Left: [[SpaceId.LEFTDOOR]],
  One_Flat_Door_Right: [[SpaceId.RIGHTDOOR]],

  One_Flat_Door_W15: [[SpaceId.LEFTDOOR], [SpaceId.RIGHTDOOR]],
  One_Shaker_Door_W15: [[SpaceId.LEFTDOOR], [SpaceId.RIGHTDOOR]],

  One_Mirror_Door_Left: [[SpaceId.LEFTDOOR]],
  One_Mirror_Door_Right: [[SpaceId.RIGHTDOOR]],

  One_Mirror_Door_W15: [[SpaceId.LEFTDOOR], [SpaceId.RIGHTDOOR]],

  One_Shaker_Door_Left: [[SpaceId.LEFTDOOR]],
  One_Shaker_Door_Right: [[SpaceId.RIGHTDOOR]],

  Hanger_W30: [
    [SpaceId.SEVEN, SpaceId.SIX, SpaceId.FIVE, SpaceId.FOUR],
    [SpaceId.THREE, SpaceId.TWO, SpaceId.ONE, SpaceId.ZERO],
    [
      SpaceId.THREE,
      SpaceId.TWO,
      SpaceId.ONE,
      SpaceId.ZERO,
      SpaceId.SIX,
      SpaceId.FIVE,
      SpaceId.FOUR,
    ],
  ],
  Hanger_W15: [
    [SpaceId.SEVEN, SpaceId.SIX, SpaceId.FIVE, SpaceId.FOUR],
    [SpaceId.THREE, SpaceId.TWO, SpaceId.ONE, SpaceId.ZERO],
    [
      SpaceId.THREE,
      SpaceId.TWO,
      SpaceId.ONE,
      SpaceId.ZERO,
      SpaceId.SIX,
      SpaceId.FIVE,
      SpaceId.FOUR,
    ],
  ],
  LeftHandle_W30: [[SpaceId.LEFTHANDLE]],
  RightHandle_W30: [[SpaceId.RIGHTHANDLE]],

  Handle_W15: [[SpaceId.RIGHTHANDLE]],

  Mirror_Door_Handle_R: [[SpaceId.RIGHTHANDLE]],
  Mirror_Door_Handle_L: [[SpaceId.LEFTHANDLE]],
  Mirror_Door_Handle_W15: [[SpaceId.RIGHTHANDLE]],
};

export const objectNames = [
  "16.5/16.5W_TOWER",
  "18/18W_TOWER",
  "19.5/19.5W_TOWER",
  "21/21W_TOWER",
  "22.5/22.5W_TOWER",
  "24/24W_TOWER",
  "25.5/25.5W_TOWER",
  "27/27W_TOWER",
  "28.5/28.5W_TOWER",
  "30/30W_TOWER",
  "31.5/31.5W_TOWER",
  "33/33W_TOWER",
  "34.5/34.5W_TOWER",
  "36/36W_TOWER",

  //   "Chest_of_Drawers",
  //   "Chest_of_Drawers_Separate",
  //   "Chest_of_Drawers_Separate_W15",
  //   "Cubby_Over_Chest",
  //   "Cubby_Shelves_D22_W30",
  //   "Two_Drawers_D22_W30",
  //   "One_Adjustable_Shelves_D22_W30",
  //   "Two_Shoe_Shelves_D22_W30",
  //   "Hanger_W30",

  //   "One_Flat_Door_Left",
  //   "One_Flat_Door_Right",

  //   "One_Flat_Door_W15",
  //   "One_Shaker_Door_W15",

  //   "One_Mirror_Door_Left",
  //   "One_Mirror_Door_Right",

  //   "One_Mirror_Door_W15",

  //   "One_Shaker_Door_Left",
  //   "One_Shaker_Door_Right",

  //   "Wardrobe_D22_W30",
  //   "Wardrobe_D22_W15",

  //   "Wardrobe_D22_ND_W30",
  //   "Wardrobe_D22_ND_W15",

  //   "One_Adjustable_Shelves_D22_W15",
  //   "Chest_of_Drawers_W15",
  //   "Cubby_Over_Chest_W15",
  //   "Cubby_Shelves_D22_W15",
  //   "Hanger_W15",
  //   "One_Shoe_Shelves_D22_W15",
  //   "Two_Drawers_D22_W15",
  //   "LeftHandle_W30",
  //   "RightHandle_W30",
  //   "Handle_W15",
  //   "Mirror_Door_Handle_R",
  //   "Mirror_Door_Handle_L",
  //   "Mirror_Door_Handle_W15",
];
export const objectIDs = {
  Chest_of_Drawers: 1001,
  Chest_of_Drawers_Separate: 1001,

  Cubby_Over_Chest: 1002,
  Cubby_Shelves_D22_W30: 1003,
  Two_Drawers_D22_W30: 1004,
  One_Adjustable_Shelves_D22_W30: 1005,
  Two_Shoe_Shelves_D22_W30: 1006,
  Hanger_W30: 1007,

  One_Flat_Door_Left: 1008,
  One_Flat_Door_Right: 1008,

  One_Flat_Door_W15: 1009,

  One_Shaker_Door_Left: 1010,
  One_Shaker_Door_Right: 1010,

  Wardrobe_D22_W30: 1011,
  Wardrobe_D22_W15: 1012,
  Wardrobe_D22_ND_W30: 1011,
  Wardrobe_D22_ND_W15: 1012,

  One_Adjustable_Shelves_D22_W15: 1013,

  Chest_of_Drawers_W15: 1014,
  Chest_of_Drawers_Separate_W15: 1014,

  Cubby_Over_Chest_W15: 1015,
  Cubby_Shelves_D22_W15: 1016,
  Hanger_W15: 1017,
  One_Shoe_Shelves_D22_W15: 1018,
  Two_Drawers_D22_W15: 1019,

  One_Mirror_Door_Left: 1020,
  One_Mirror_Door_Right: 1020,

  One_Mirror_Door_W15: 1021,
  One_Shaker_Door_W15: 2022,
  LeftHandle_W30: 2023,
  RightHandle_W30: 2023,
  Handle_W30: 2023,
  Mirror_Door_Handle_L: 2023,
  Mirror_Door_Handle_R: 2023,
  Mirror_Door_Handle_W15: 2023,
};

// List of just wardrobes
export const bigWardrobeNames = [
  "16.5/16.5W_TOWER",
  "18/18W_TOWER",
  "19.5/19.5W_TOWER",
  "21/21W_TOWER",
  "22.5/22.5W_TOWER",
  "24/24W_TOWER",
  "25.5/25.5W_TOWER",
  "27/27W_TOWER",
  "28.5/28.5W_TOWER",
  "30/30W_TOWER",
  "31.5/31.5W_TOWER",
  "33/33W_TOWER",
  "34.5/34.5W_TOWER",
  "36/36W_TOWER",
  //   "Wardrobe_D22_W30",
  //   "Wardrobe_D22_ND_W30",
];
// var smallWardrobeNames = ["Wardrobe_D22_W15", "Wardrobe_D22_ND_W15"];

export const WardrobeSize = [
  {
    name: "Wardrobe_D22_W30",
    width: "30",
    height: "84",
    halfWidth: 0.23,
    halfHeight: 0.23,
  },
  {
    name: "Wardrobe_D22_W15",
    width: "15",
    height: "84",
    halfWidth: 0.23,
    halfHeight: 0.23,
  },
  {
    name: "Wardrobe_D22_ND_W30",
    width: "30",
    height: "84",
    halfWidth: 0.23,
    halfHeight: 0.23,
  },
  {
    name: "Wardrobe_D22_ND_W15",
    width: "15",
    height: "84",
    halfWidth: 0.23,
    halfHeight: 0.23,
  },
  //   { name: "16W_TOWER", width: "16", height: "84" },
  {
    name: "16.5/16.5W_TOWER",
    width: "16.5",
    height: "84",
    halfWidth: 0.23,
    halfHeight: 0.23,
  },
  {
    name: "18/18W_TOWER",
    width: "18",
    height: "84",
    halfWidth: 0.23,
    halfHeight: 0.23,
  },
  {
    name: "19.5/19.5W_TOWER",
    width: "19.5",
    height: "84",
    halfWidth: 0.23,
    halfHeight: 0.23,
  },
  {
    name: "21/21W_TOWER",
    width: "21",
    height: "84",
    halfWidth: 0.23,
    halfHeight: 0.23,
  },
  {
    name: "22.5/22.5W_TOWER",
    width: "22.5",
    height: "84",
    halfWidth: 0.23,
    halfHeight: 0.23,
  },
  {
    name: "24/24W_TOWER",
    width: "24",
    height: "84",
    halfWidth: 0.23,
    halfHeight: 0.23,
  },
  {
    name: "25.5/25.5W_TOWER",
    width: "25.5",
    height: "84",
    halfWidth: 0.23,
    halfHeight: 0.23,
  },
  {
    name: "27/27W_TOWER",
    width: "27",
    height: "84",
    halfWidth: 0.23,
    halfHeight: 0.23,
  },
  {
    name: "28.5/28.5W_TOWER",
    width: "28.5",
    height: "84",
    halfWidth: 0.23,
    halfHeight: 0.23,
  },
  {
    name: "30/30W_TOWER",
    width: "30",
    height: "84",
    halfWidth: 0.23,
    halfHeight: 0.23,
  },
  {
    name: "31.5/31.5W_TOWER",
    width: "31.5",
    height: "84",
    halfWidth: 0.23,
    halfHeight: 0.23,
  },
  {
    name: "33/33W_TOWER",
    width: "33",
    height: "84",
    halfWidth: 0.23,
    halfHeight: 0.23,
  },
  {
    name: "34.5/34.5W_TOWER",
    width: "34.5",
    height: "84",
    halfWidth: 0.23,
    halfHeight: 0.23,
  },
  {
    name: "36/36W_TOWER",
    width: "36",
    height: "84",
    halfWidth: 0.23,
    halfHeight: 0.23,
  },
];

export const elementsW30 = [
  "Chest_of_Drawers",
  "Chest_of_Drawers_Separate",
  "Cubby_Over_Chest",
  "Cubby_Shelves_D22_W30",
  "Two_Drawers_D22_W30",
  "One_Adjustable_Shelves_D22_W30",
  "Two_Shoe_Shelves_D22_W30",
  "Hanger_W30",
  "One_Flat_Door_Left",
  "One_Flat_Door_Right",
  "One_Mirror_Door_Left",
  "One_Mirror_Door_Right",
  "One_Shaker_Door_Left",
  "One_Shaker_Door_Right",
];

export const elementsW30Bottom = [
  { name: "Chest_of_Drawers", index: 0 },
  { name: "Chest_of_Drawers_Separate", index: 0 },
  { name: "Cubby_Over_Chest", index: 0 },
  { name: "Two_Drawers_D22_W30", index: 0 },
  { name: "Two_Drawers_D22_W30", index: 1 },
  { name: "One_Adjustable_Shelves_D22_W30", index: 0 },
  { name: "One_Adjustable_Shelves_D22_W30", index: 1 },
  { name: "Two_Shoe_Shelves_D22_W30", index: 0 },
  { name: "Hanger_W30", index: 1 },
];

export const elementsW30Top = [
  { name: "Cubby_Shelves_D22_W30", index: 0 },
  { name: "One_Adjustable_Shelves_D22_W30", index: 2 },
  { name: "One_Adjustable_Shelves_D22_W30", index: 3 },
  { name: "One_Adjustable_Shelves_D22_W30", index: 4 },
  { name: "One_Adjustable_Shelves_D22_W30", index: 5 },
  { name: "Hanger_W30", index: 0 },
  { name: "Hanger_W30", index: 2 },
];

export const elementsW30Doors = [
  { name: "One_Flat_Door_Right", index: 0 },
  { name: "One_Flat_Door_Left", index: 0 },
  { name: "One_Mirror_Door_Right", index: 0 },
  { name: "One_Mirror_Door_Left", index: 0 },
  { name: "One_Shaker_Door_Right", index: 0 },
  { name: "One_Shaker_Door_Left", index: 0 },
  { name: "LeftHandle_W30", index: 0 },
  { name: "RightHandle_W30", index: 0 },
  { name: "Mirror_Door_Handle_R", index: 0 },
  { name: "Mirror_Door_Handle_L", index: 0 },
];
///

export const elementsW15 = [
  "One_Adjustable_Shelves_D22_W15",
  "Chest_of_Drawers_W15",
  "Chest_of_Drawers_Separate_W15",
  "Cubby_Over_Chest_W15",
  "Cubby_Shelves_D22_W15",
  "Hanger_W15",
  "One_Shoe_Shelves_D22_W15",
  "Two_Drawers_D22_W15",
  "One_Flat_Door_W15",
  "One_Mirror_Door_W15",
  "One_Shaker_Door_W15",
  "Handle_W15",
];
//
export const elementsW15Top = [
  { name: "One_Adjustable_Shelves_D22_W15", index: 2 },
  { name: "One_Adjustable_Shelves_D22_W15", index: 3 },
  { name: "One_Adjustable_Shelves_D22_W15", index: 4 },
  { name: "One_Adjustable_Shelves_D22_W15", index: 5 },
  { name: "Cubby_Shelves_D22_W15", index: 0 },
  { name: "Hanger_W15", index: 0 },
  { name: "Hanger_W15", index: 2 },
];

export const elementsW15Bottom = [
  { name: "One_Adjustable_Shelves_D22_W15", index: 0 },
  { name: "One_Adjustable_Shelves_D22_W15", index: 1 },
  { name: "Chest_of_Drawers_W15", index: 0 },
  { name: "Chest_of_Drawers_Separate_W15", index: 0 },
  { name: "Cubby_Over_Chest_W15", index: 0 },
  { name: "Hanger_W15", index: 1 },
  { name: "One_Shoe_Shelves_D22_W15", index: 0 },
  { name: "One_Shoe_Shelves_D22_W15", index: 1 },
  { name: "Two_Drawers_D22_W15", index: 0 },
  { name: "Two_Drawers_D22_W15", index: 1 },
];

export const elementsW15Door = [
  { name: "One_Flat_Door_W15", index: 0 },
  { name: "One_Mirror_Door_W15", index: 0 },
  { name: "One_Shaker_Door_W15", index: 0 },
  { name: "Handle_W15", index: 0 },
  { name: "Mirror_Door_Handle_W15", index: 0 },
];

export const hardware = {
  drawer: {
    knob: [
      "PULL_KNOB_DR_BLACK",
      "PULL_KNOB_DR_BRASS",
      "PULL_KNOB_DR_CHROME",
      "PULL_KNOB_DR_NICKEL",
      "PULL_KNOB_DR_M_BLACK",
      "PULL_KNOB_DR_M_BRASS",
      "PULL_KNOB_DR_M_CHROME",
      "PULL_KNOB_DR_M_NICKEL",
    ],
    pull: [
      "PULL_MODERN_DR_BLACK",
      "PULL_MODERN_DR_BRASS",
      "PULL_MODERN_DR_CHROME",
      "PULL_MODERN_DR_NICKEL",
      "PULL_MODERN_DR_M_BLACK",
      "PULL_MODERN_DR_M_BRASS",
      "PULL_MODERN_DR_M_CHROME",
      "PULL_MODERN_DR_M_NICKEL",
    ],
  },
  door: {
    knob: [
      "PULL_KNOB_R_BLACK",
      "PULL_KNOB_R_BRASS",
      "PULL_KNOB_R_CHROME",
      "PULL_KNOB_R_NICKEL",
      "PULL_KNOB_L_BLACK",
      "PULL_KNOB_L_BRASS",
      "PULL_KNOB_L_CHROME",
      "PULL_KNOB_L_NICKEL",
      "PULL_KNOB_S_BLACK",
      "PULL_KNOB_S_BRASS",
      "PULL_KNOB_S_CHROME",
      "PULL_KNOB_S_NICKEL",
    ],
    pull: [
      "PULL_MODERN_R_BLACK",
      "PULL_MODERN_R_BRASS",
      "PULL_MODERN_R_CHROME",
      "PULL_MODERN_R_NICKEL",
      "PULL_MODERN_L_BLACK",
      "PULL_MODERN_L_BRASS",
      "PULL_MODERN_L_CHROME",
      "PULL_MODERN_L_NICKEL",
      "PULL_MODERN_S_BLACK",
      "PULL_MODERN_S_BRASS",
      "PULL_MODERN_S_CHROME",
      "PULL_MODERN_S_NICKEL",
    ],
  },
  rod: [
    "ROD_BLACK",
    "ROD_BRASS",
    "ROD_CHROME",
    "ROD_NICKEL",
  ]
};

export const extraKnobDR = [
  // "Extra PULL_KNOB_DR_M_BLACK TOP1",
  // "Extra PULL_KNOB_DR_M_BLACK TOP2",
  "Extra PULL_KNOB_DR_BLACK TOP1",
  "Extra PULL_KNOB_DR_BLACK TOP2",
  "Extra PULL_KNOB_DR_BLACK TOP3",
  "Extra PULL_KNOB_DR_BLACK TOP4",

  // "Extra PULL_KNOB_DR_M_BRASS TOP1",
  // "Extra PULL_KNOB_DR_M_BRASS TOP2",
  "Extra PULL_KNOB_DR_BRASS TOP1",
  "Extra PULL_KNOB_DR_BRASS TOP2",
  "Extra PULL_KNOB_DR_BRASS TOP3",
  "Extra PULL_KNOB_DR_BRASS TOP4",

  // "Extra PULL_KNOB_DR_M_CHROME TOP1",
  // "Extra PULL_KNOB_DR_M_CHROME TOP2",
  "Extra PULL_KNOB_DR_CHROME TOP1",
  "Extra PULL_KNOB_DR_CHROME TOP2",
  "Extra PULL_KNOB_DR_CHROME TOP3",
  "Extra PULL_KNOB_DR_CHROME TOP4",

  // "Extra PULL_KNOB_DR_M_NICKEL TOP1",
  // "Extra PULL_KNOB_DR_M_NICKEL TOP2",
  "Extra PULL_KNOB_DR_NICKEL TOP1",
  "Extra PULL_KNOB_DR_NICKEL TOP2",
  "Extra PULL_KNOB_DR_NICKEL TOP3",
  "Extra PULL_KNOB_DR_NICKEL TOP4",

  "Extra PULL_KNOB_DR_M_BLACK BOTTOM1",
  "Extra PULL_KNOB_DR_M_BLACK BOTTOM2",
  "Extra PULL_KNOB_DR_BLACK BOTTOM1",
  "Extra PULL_KNOB_DR_BLACK BOTTOM2",
  "Extra PULL_KNOB_DR_BLACK BOTTOM3",
  "Extra PULL_KNOB_DR_BLACK BOTTOM4",

  "Extra PULL_KNOB_DR_M_BRASS BOTTOM1",
  "Extra PULL_KNOB_DR_M_BRASS BOTTOM2",
  "Extra PULL_KNOB_DR_BRASS BOTTOM1",
  "Extra PULL_KNOB_DR_BRASS BOTTOM2",
  "Extra PULL_KNOB_DR_BRASS BOTTOM3",
  "Extra PULL_KNOB_DR_BRASS BOTTOM4",

  "Extra PULL_KNOB_DR_M_CHROME BOTTOM1",
  "Extra PULL_KNOB_DR_M_CHROME BOTTOM2",
  "Extra PULL_KNOB_DR_CHROME BOTTOM1",
  "Extra PULL_KNOB_DR_CHROME BOTTOM2",
  "Extra PULL_KNOB_DR_CHROME BOTTOM3",
  "Extra PULL_KNOB_DR_CHROME BOTTOM4",

  "Extra PULL_KNOB_DR_M_NICKEL BOTTOM1",
  "Extra PULL_KNOB_DR_M_NICKEL BOTTOM2",
  "Extra PULL_KNOB_DR_NICKEL BOTTOM1",
  "Extra PULL_KNOB_DR_NICKEL BOTTOM2",
  "Extra PULL_KNOB_DR_NICKEL BOTTOM3",
  "Extra PULL_KNOB_DR_NICKEL BOTTOM4",
];

export const extraPullDR = [
  // "Extra PULL_MODERN_DR_M_BLACK TOP1",
  // "Extra PULL_MODERN_DR_M_BLACK TOP2",
  "Extra PULL_MODERN_DR_BLACK TOP1",
  "Extra PULL_MODERN_DR_BLACK TOP2",
  "Extra PULL_MODERN_DR_BLACK TOP3",
  "Extra PULL_MODERN_DR_BLACK TOP4",

  // "Extra PULL_MODERN_DR_M_BRASS TOP1",
  // "Extra PULL_MODERN_DR_M_BRASS TOP2",
  "Extra PULL_MODERN_DR_BRASS TOP1",
  "Extra PULL_MODERN_DR_BRASS TOP2",
  "Extra PULL_MODERN_DR_BRASS TOP3",
  "Extra PULL_MODERN_DR_BRASS TOP4",

  // "Extra PULL_MODERN_DR_M_CHROME TOP1",
  // "Extra PULL_MODERN_DR_M_CHROME TOP2",
  "Extra PULL_MODERN_DR_CHROME TOP1",
  "Extra PULL_MODERN_DR_CHROME TOP2",
  "Extra PULL_MODERN_DR_CHROME TOP3",
  "Extra PULL_MODERN_DR_CHROME TOP4",

  // "Extra PULL_MODERN_DR_M_NICKEL TOP1",
  // "Extra PULL_MODERN_DR_M_NICKEL TOP2",
  "Extra PULL_MODERN_DR_NICKEL TOP1",
  "Extra PULL_MODERN_DR_NICKEL TOP2",
  "Extra PULL_MODERN_DR_NICKEL TOP3",
  "Extra PULL_MODERN_DR_NICKEL TOP4",

  "Extra PULL_MODERN_DR_M_BLACK BOTTOM1",
  "Extra PULL_MODERN_DR_M_BLACK BOTTOM2",
  "Extra PULL_MODERN_DR_BLACK BOTTOM1",
  "Extra PULL_MODERN_DR_BLACK BOTTOM2",
  "Extra PULL_MODERN_DR_BLACK BOTTOM3",
  "Extra PULL_MODERN_DR_BLACK BOTTOM4",

  "Extra PULL_MODERN_DR_M_BRASS BOTTOM1",
  "Extra PULL_MODERN_DR_M_BRASS BOTTOM2",
  "Extra PULL_MODERN_DR_BRASS BOTTOM1",
  "Extra PULL_MODERN_DR_BRASS BOTTOM2",
  "Extra PULL_MODERN_DR_BRASS BOTTOM3",
  "Extra PULL_MODERN_DR_BRASS BOTTOM4",

  "Extra PULL_MODERN_DR_M_CHROME BOTTOM1",
  "Extra PULL_MODERN_DR_M_CHROME BOTTOM2",
  "Extra PULL_MODERN_DR_CHROME BOTTOM1",
  "Extra PULL_MODERN_DR_CHROME BOTTOM2",
  "Extra PULL_MODERN_DR_CHROME BOTTOM3",
  "Extra PULL_MODERN_DR_CHROME BOTTOM4",

  "Extra PULL_MODERN_DR_M_NICKEL BOTTOM1",
  "Extra PULL_MODERN_DR_M_NICKEL BOTTOM2",
  "Extra PULL_MODERN_DR_NICKEL BOTTOM1",
  "Extra PULL_MODERN_DR_NICKEL BOTTOM2",
  "Extra PULL_MODERN_DR_NICKEL BOTTOM3",
  "Extra PULL_MODERN_DR_NICKEL BOTTOM4",
];

export const elementParts = {
  "16.5/16.5W_TOWER": {
    top: [
      "16.5/16.5W_ROD",
      "16.5/16.5W_ROD_BLACK",
      "16.5/16.5W_ROD_BRASS",
      "16.5/16.5W_ROD_CHROME",
      "16.5/16.5W_ROD_NICKEL",
      "16.5/16.5W_SHELF",
      "16.5/16.5W_SHELF_DP14",
      "Extra 16.5/16.5W_SHELF_DP14 1",
      "Extra 16.5/16.5W_SHELF_DP14 2",
      "Extra 16.5/16.5W_SHELF_DP14 3",
      "Extra 16.5/16.5W_SHELF MIDDLE",
      "Extra 16.5/16.5W_SHELF 1",
      "Extra 16.5/16.5W_SHELF 2",
      "Extra 16.5/16.5W_SHELF 3",
      "Extra 16.5/16.5W_ROD 1",
      "Extra 16.5/16.5W_ROD_BLACK 1",
      "Extra 16.5/16.5W_ROD_BRASS 1",
      "Extra 16.5/16.5W_ROD_CHROME 1",
      "Extra 16.5/16.5W_ROD_NICKEL 1",
    ],
    bottom: [
      "16.5/16.5W_ROD",
      "16.5/16.5W_ROD_BLACK",
      "16.5/16.5W_ROD_BRASS",
      "16.5/16.5W_ROD_CHROME",
      "16.5/16.5W_ROD_NICKEL",
      "16.5/16.5W_SHELF",
      "16.5/16.5W_SHELF_DP14",
      "Extra 16.5/16.5W_SHELF_DP14 1",
      "Extra 16.5/16.5W_SHELF_DP14 2",
      "Extra 16.5/16.5W_SHELF 1",
      "Extra 16.5/16.5W_SHELF 2",
    ],
    door: ["16.5/16.5W_FDO", "16.5/16.5W_3QD", "16.5/16.5W_HDO"],
    doorHardware: [
      "PULL_KNOB_S_BLACK",
      "PULL_KNOB_S_BRASS",
      "PULL_KNOB_S_CHROME",
      "PULL_KNOB_S_NICKEL",

      "Extra PULL_KNOB_S_BLACK TOP",
      "Extra PULL_KNOB_S_BRASS TOP",
      "Extra PULL_KNOB_S_CHROME TOP",
      "Extra PULL_KNOB_S_NICKEL TOP",
      // ],
      // pull: [
      "PULL_MODERN_S_BLACK",
      "PULL_MODERN_S_BRASS",
      "PULL_MODERN_S_CHROME",
      "PULL_MODERN_S_NICKEL",

      "Extra PULL_MODERN_S_BLACK TOP",
      "Extra PULL_MODERN_S_BRASS TOP",
      "Extra PULL_MODERN_S_CHROME TOP",
      "Extra PULL_MODERN_S_NICKEL TOP",
    ],
  },
  "18/18W_TOWER": {
    top: [
      "18/18W_ROD",
      "18/18W_ROD_BLACK",
      "18/18W_ROD_BRASS",
      "18/18W_ROD_CHROME",
      "18/18W_ROD_NICKEL",
      "18/18W_SHELF",
      "18/18W_SHELF_DP14",
      "Extra 18/18W_SHELF_DP14 1",
      "Extra 18/18W_SHELF_DP14 2",
      "Extra 18/18W_SHELF_DP14 3",
      "18/18W_SS",
      "18/18W_SS_DP14",
      "18/18W_DR",
      "Extra 18/18W_DR 1",
      "Extra 18/18W_DR 2",
      "Extra 18/18W_DR 3",
      "Extra 18/18W_DR 4",
      "18/18W_CUBBY",
      "18/18W_CUBBY_DP14",
      "Extra 18/18W_SHELF MIDDLE",
      "Extra 18/18W_SHELF 1",
      "Extra 18/18W_SHELF 2",
      "Extra 18/18W_SHELF 3",
      "Extra 18/18W_ROD 1",
      "Extra 18/18W_ROD_BLACK 1",
      "Extra 18/18W_ROD_BRASS 1",
      "Extra 18/18W_ROD_CHROME 1",
      "Extra 18/18W_ROD_NICKEL 1",
      "Extra 18/18W_SS 1",
      "Extra 18/18W_SS 2",
      "Extra 18/18W_SS 3",
      "Extra 18/18W_SS 4",
      "Extra 18/18W_SS_DP14 1",
      "Extra 18/18W_SS_DP14 2",
      "Extra 18/18W_SS_DP14 3",
      "Extra 18/18W_SS_DP14 4",
    ],
    bottom: [
      "18/18W_ROD",
      "18/18W_ROD_BLACK",
      "18/18W_ROD_BRASS",
      "18/18W_ROD_CHROME",
      "18/18W_ROD_NICKEL",
      "18/18W_SHELF",
      "18/18W_SHELF_DP14",
      "Extra 18/18W_SHELF_DP14 1",
      "Extra 18/18W_SHELF_DP14 2",
      "Extra 18/18W_SHELF 1",
      "Extra 18/18W_SHELF 2",
      "18/18W_SS",
      "18/18W_SS_DP14",
      "18/18W_DR",
      "Extra 18/18W_DR 1",
      "Extra 18/18W_DR 2",
      "Extra 18/18W_DR 3",
      "Extra 18/18W_DR 4",
      "18/18W_CUBBY",
      "18/18W_CUBBY_DP14",
      "Extra 18/18W_SS 1",
      "Extra 18/18W_SS 2",
      "Extra 18/18W_SS 3",
      "Extra 18/18W_SS 4",
      "Extra 18/18W_SS_DP14 1",
      "Extra 18/18W_SS_DP14 2",
      "Extra 18/18W_SS_DP14 3",
      "Extra 18/18W_SS_DP14 4",
      "18/18W_DR_S",
      "Extra 18/18W_DR_S 1",
      "Extra 18/18W_DR_S 2",
    ],
    door: ["18/18W_FDO", "18/18W_3QD", "18/18W_HDO"],
    doorHardware: [
      "PULL_KNOB_S_BLACK",
      "PULL_KNOB_S_BRASS",
      "PULL_KNOB_S_CHROME",
      "PULL_KNOB_S_NICKEL",

      "Extra PULL_KNOB_S_BLACK TOP",
      "Extra PULL_KNOB_S_BRASS TOP",
      "Extra PULL_KNOB_S_CHROME TOP",
      "Extra PULL_KNOB_S_NICKEL TOP",

      // ...extraKnobDR,
      // ],
      // pull: [
      "PULL_MODERN_S_BLACK",
      "PULL_MODERN_S_BRASS",
      "PULL_MODERN_S_CHROME",
      "PULL_MODERN_S_NICKEL",

      "Extra PULL_MODERN_S_BLACK TOP",
      "Extra PULL_MODERN_S_BRASS TOP",
      "Extra PULL_MODERN_S_CHROME TOP",
      "Extra PULL_MODERN_S_NICKEL TOP",

      // ...extraPullDR,
    ],
    drawerHardware: [
      ...extraKnobDR,
      ...extraPullDR,
    ]
  },
  "19.5/19.5W_TOWER": {
    top: [
      "19.5/19.5W_ROD",
      "19.5/19.5W_ROD_BLACK",
      "19.5/19.5W_ROD_BRASS",
      "19.5/19.5W_ROD_CHROME",
      "19.5/19.5W_ROD_NICKEL",
      "19.5/19.5W_SHELF",
      "19.5/19.5W_SHELF_DP14",
      "Extra 19.5/19.5W_SHELF_DP14 1",
      "Extra 19.5/19.5W_SHELF_DP14 2",
      "Extra 19.5/19.5W_SHELF_DP14 3",
      "Extra 19.5/19.5W_SHELF MIDDLE",
      "Extra 19.5/19.5W_SHELF 1",
      "Extra 19.5/19.5W_SHELF 2",
      "Extra 19.5/19.5W_SHELF 3",
      "Extra 19.5/19.5W_ROD 1",
      "Extra 19.5/19.5W_ROD_BLACK 1",
      "Extra 19.5/19.5W_ROD_BRASS 1",
      "Extra 19.5/19.5W_ROD_CHROME 1",
      "Extra 19.5/19.5W_ROD_NICKEL 1",
    ],
    bottom: [
      "19.5/19.5W_ROD",
      "19.5/19.5W_ROD_BLACK",
      "19.5/19.5W_ROD_BRASS",
      "19.5/19.5W_ROD_CHROME",
      "19.5/19.5W_ROD_NICKEL",
      "19.5/19.5W_SHELF",
      "19.5/19.5W_SHELF_DP14",
      "Extra 19.5/19.5W_SHELF_DP14 1",
      "Extra 19.5/19.5W_SHELF_DP14 2",
      "Extra 19.5/19.5W_SHELF 1",
      "Extra 19.5/19.5W_SHELF 2",
    ],
    door: ["19.5/19.5W_FDO", "19.5/19.5W_3QD", "19.5/19.5W_HDO"],
    doorHardware: [
      "PULL_KNOB_S_BLACK",
      "PULL_KNOB_S_BRASS",
      "PULL_KNOB_S_CHROME",
      "PULL_KNOB_S_NICKEL",

      "Extra PULL_KNOB_S_BLACK TOP",
      "Extra PULL_KNOB_S_BRASS TOP",
      "Extra PULL_KNOB_S_CHROME TOP",
      "Extra PULL_KNOB_S_NICKEL TOP",
      // ],
      // pull: [
      "PULL_MODERN_S_BLACK",
      "PULL_MODERN_S_BRASS",
      "PULL_MODERN_S_CHROME",
      "PULL_MODERN_S_NICKEL",

      "Extra PULL_MODERN_S_BLACK TOP",
      "Extra PULL_MODERN_S_BRASS TOP",
      "Extra PULL_MODERN_S_CHROME TOP",
      "Extra PULL_MODERN_S_NICKEL TOP",
    ],
  },
  "21/21W_TOWER": {
    top: [
      "21/21W_ROD",
      "21/21W_ROD_BLACK",
      "21/21W_ROD_BRASS",
      "21/21W_ROD_CHROME",
      "21/21W_ROD_NICKEL",
      "21/21W_SHELF",
      "21/21W_SHELF_DP14",
      "Extra 21/21W_SHELF_DP14 1",
      "Extra 21/21W_SHELF_DP14 2",
      "Extra 21/21W_SHELF_DP14 3",
      "Extra 21/21W_SHELF MIDDLE",
      "Extra 21/21W_SHELF 1",
      "Extra 21/21W_SHELF 2",
      "Extra 21/21W_SHELF 3",
      "Extra 21/21W_ROD 1",
      "Extra 21/21W_ROD_BLACK 1",
      "Extra 21/21W_ROD_BRASS 1",
      "Extra 21/21W_ROD_CHROME 1",
      "Extra 21/21W_ROD_NICKEL 1",
    ],
    bottom: [
      "21/21W_ROD",
      "21/21W_ROD_BLACK",
      "21/21W_ROD_BRASS",
      "21/21W_ROD_CHROME",
      "21/21W_ROD_NICKEL",
      "21/21W_SHELF",
      "21/21W_SHELF_DP14",
      "Extra 21/21W_SHELF_DP14 1",
      "Extra 21/21W_SHELF_DP14 2",
      "Extra 21/21W_SHELF 1",
      "Extra 21/21W_SHELF 2",
    ],
    door: ["21/21W_FDO", "21/21W_3QD", "21/21W_HDO"],
    doorHardware: [
      "PULL_KNOB_S_BLACK",
      "PULL_KNOB_S_BRASS",
      "PULL_KNOB_S_CHROME",
      "PULL_KNOB_S_NICKEL",

      "Extra PULL_KNOB_S_BLACK TOP",
      "Extra PULL_KNOB_S_BRASS TOP",
      "Extra PULL_KNOB_S_CHROME TOP",
      "Extra PULL_KNOB_S_NICKEL TOP",
      // ],
      // pull: [
      "PULL_MODERN_S_BLACK",
      "PULL_MODERN_S_BRASS",
      "PULL_MODERN_S_CHROME",
      "PULL_MODERN_S_NICKEL",

      "Extra PULL_MODERN_S_BLACK TOP",
      "Extra PULL_MODERN_S_BRASS TOP",
      "Extra PULL_MODERN_S_CHROME TOP",
      "Extra PULL_MODERN_S_NICKEL TOP",
    ],
  },
  "22.5/22.5W_TOWER": {
    top: [
      "22.5/22.5W_ROD",
      "22.5/22.5W_ROD_BLACK",
      "22.5/22.5W_ROD_BRASS",
      "22.5/22.5W_ROD_CHROME",
      "22.5/22.5W_ROD_NICKEL",
      "22.5/22.5W_SHELF",
      "22.5/22.5W_SHELF_DP14",
      "Extra 22.5/22.5W_SHELF_DP14 1",
      "Extra 22.5/22.5W_SHELF_DP14 2",
      "Extra 22.5/22.5W_SHELF_DP14 3",
      "Extra 22.5/22.5W_SHELF MIDDLE",
      "Extra 22.5/22.5W_SHELF 1",
      "Extra 22.5/22.5W_SHELF 2",
      "Extra 22.5/22.5W_SHELF 3",
      "Extra 22.5/22.5W_ROD 1",
      "Extra 22.5/22.5W_ROD_BLACK 1",
      "Extra 22.5/22.5W_ROD_BRASS 1",
      "Extra 22.5/22.5W_ROD_CHROME 1",
      "Extra 22.5/22.5W_ROD_NICKEL 1",
      "22.5/22.5W_FHD_L",
      "22.5/22.5W_FHD_R",
      "22.5/22.5W_HDO_L",
      "22.5/22.5W_HDO_R",
    ],
    bottom: [
      "22.5/22.5W_ROD",
      "22.5/22.5W_ROD_BLACK",
      "22.5/22.5W_ROD_BRASS",
      "22.5/22.5W_ROD_CHROME",
      "22.5/22.5W_ROD_NICKEL",
      "22.5/22.5W_SHELF",
      "22.5/22.5W_SHELF_DP14",
      "Extra 22.5/22.5W_SHELF_DP14 1",
      "Extra 22.5/22.5W_SHELF_DP14 2",
      "Extra 22.5/22.5W_SHELF 1",
      "Extra 22.5/22.5W_SHELF 2",
      "22.5/22.5W_FHD_L",
      "22.5/22.5W_FHD_R",
      "22.5/22.5W_HDO_L",
      "22.5/22.5W_HDO_R",
    ],
    door: [
      "22.5/22.5W_FHD_L",
      "22.5/22.5W_FHD_R",
      "22.5/22.5W_3QD_L",
      "22.5/22.5W_3QD_R",
      "22.5/22.5W_HDO_L",
      "22.5/22.5W_HDO_R",
    ],
    doorHardware: [
      "PULL_KNOB_R_BLACK",
      "PULL_KNOB_R_BRASS",
      "PULL_KNOB_R_CHROME",
      "PULL_KNOB_R_NICKEL",
      "PULL_KNOB_L_BLACK",
      "PULL_KNOB_L_BRASS",
      "PULL_KNOB_L_CHROME",
      "PULL_KNOB_L_NICKEL",

      "Extra PULL_KNOB_R_BLACK TOP",
      "Extra PULL_KNOB_R_BRASS TOP",
      "Extra PULL_KNOB_R_CHROME TOP",
      "Extra PULL_KNOB_R_NICKEL TOP",
      "Extra PULL_KNOB_L_BLACK TOP",
      "Extra PULL_KNOB_L_BRASS TOP",
      "Extra PULL_KNOB_L_CHROME TOP",
      "Extra PULL_KNOB_L_NICKEL TOP",
      // ],
      // pull: [
      "PULL_MODERN_R_BLACK",
      "PULL_MODERN_R_BRASS",
      "PULL_MODERN_R_CHROME",
      "PULL_MODERN_R_NICKEL",
      "PULL_MODERN_L_BLACK",
      "PULL_MODERN_L_BRASS",
      "PULL_MODERN_L_CHROME",
      "PULL_MODERN_L_NICKEL",

      "Extra PULL_MODERN_R_BLACK TOP",
      "Extra PULL_MODERN_R_BRASS TOP",
      "Extra PULL_MODERN_R_CHROME TOP",
      "Extra PULL_MODERN_R_NICKEL TOP",
      "Extra PULL_MODERN_L_BLACK TOP",
      "Extra PULL_MODERN_L_BRASS TOP",
      "Extra PULL_MODERN_L_CHROME TOP",
      "Extra PULL_MODERN_L_NICKEL TOP",
    ],
  },
  "24/24W_TOWER": {
    top: [
      "24/24W_ROD",
      "24/24W_ROD_BLACK",
      "24/24W_ROD_BRASS",
      "24/24W_ROD_CHROME",
      "24/24W_ROD_NICKEL",
      "24/24W_SHELF",
      "24/24W_SHELF_DP14",
      "Extra 24/24W_SHELF_DP14 1",
      "Extra 24/24W_SHELF_DP14 2",
      "Extra 24/24W_SHELF_DP14 3",
      "24/24W_SS",
      "24/24W_SS_DP14",
      "24/24W_DR",
      "Extra 24/24W_DR 1",
      "Extra 24/24W_DR 2",
      "Extra 24/24W_DR 3",
      "Extra 24/24W_DR 4",
      "24/24W_CUBBY",
      "24/24W_CUBBY_DP14",
      "Extra 24/24W_SHELF MIDDLE",
      "Extra 24/24W_SHELF 1",
      "Extra 24/24W_SHELF 2",
      "Extra 24/24W_SHELF 3",
      "Extra 24/24W_ROD 1",
      "Extra 24/24W_ROD_BLACK 1",
      "Extra 24/24W_ROD_BRASS 1",
      "Extra 24/24W_ROD_CHROME 1",
      "Extra 24/24W_ROD_NICKEL 1",
      "Extra 24/24W_SS 1",
      "Extra 24/24W_SS 2",
      "Extra 24/24W_SS 3",
      "Extra 24/24W_SS 4",
      "Extra 24/24W_SS_DP14 1",
      "Extra 24/24W_SS_DP14 2",
      "Extra 24/24W_SS_DP14 3",
      "Extra 24/24W_SS_DP14 4",
      "24/24W_FHD_L",
      "24/24W_FHD_R",
      "24/24W_HDO_L",
      "24/24W_HDO_R",
    ],
    bottom: [
      "24/24W_ROD",
      "24/24W_ROD_BLACK",
      "24/24W_ROD_BRASS",
      "24/24W_ROD_CHROME",
      "24/24W_ROD_NICKEL",
      "24/24W_SHELF",
      "24/24W_SHELF_DP14",
      "Extra 24/24W_SHELF_DP14 1",
      "Extra 24/24W_SHELF_DP14 2",
      "24/24W_SS",
      "24/24W_SS_DP14",
      "24/24W_DR",
      "Extra 24/24W_DR 1",
      "Extra 24/24W_DR 2",
      "Extra 24/24W_DR 3",
      "Extra 24/24W_DR 4",
      "24/24W_CUBBY",
      "24/24W_CUBBY_DP14",
      "Extra 24/24W_SS 1",
      "Extra 24/24W_SS 2",
      "Extra 24/24W_SS 3",
      "Extra 24/24W_SS 4",
      "Extra 24/24W_SS_DP14 1",
      "Extra 24/24W_SS_DP14 2",
      "Extra 24/24W_SS_DP14 3",
      "Extra 24/24W_SS_DP14 4",
      "Extra 24/24W_SHELF 1",
      "Extra 24/24W_SHELF 2",
      "24/24W_DR_S",
      "Extra 24/24W_DR_S 1",
      "Extra 24/24W_DR_S 2",
      "24/24W_FHD_L",
      "24/24W_FHD_R",
      "24/24W_HDO_L",
      "24/24W_HDO_R",
    ],
    door: [
      "24/24W_FHD_L",
      "24/24W_FHD_R",
      "24/24W_3QD_L",
      "24/24W_3QD_R",
      "24/24W_HDO_L",
      "24/24W_HDO_R",
    ],
    doorHardware: [
      "PULL_KNOB_R_BLACK",
      "PULL_KNOB_R_BRASS",
      "PULL_KNOB_R_CHROME",
      "PULL_KNOB_R_NICKEL",
      "PULL_KNOB_L_BLACK",
      "PULL_KNOB_L_BRASS",
      "PULL_KNOB_L_CHROME",
      "PULL_KNOB_L_NICKEL",

      "Extra PULL_KNOB_R_BLACK TOP",
      "Extra PULL_KNOB_R_BRASS TOP",
      "Extra PULL_KNOB_R_CHROME TOP",
      "Extra PULL_KNOB_R_NICKEL TOP",
      "Extra PULL_KNOB_L_BLACK TOP",
      "Extra PULL_KNOB_L_BRASS TOP",
      "Extra PULL_KNOB_L_CHROME TOP",
      "Extra PULL_KNOB_L_NICKEL TOP",

      //   ...extraKnobDR,
      // ],
      // pull: [
      "PULL_MODERN_R_BLACK",
      "PULL_MODERN_R_BRASS",
      "PULL_MODERN_R_CHROME",
      "PULL_MODERN_R_NICKEL",
      "PULL_MODERN_L_BLACK",
      "PULL_MODERN_L_BRASS",
      "PULL_MODERN_L_CHROME",
      "PULL_MODERN_L_NICKEL",

      "Extra PULL_MODERN_R_BLACK TOP",
      "Extra PULL_MODERN_R_BRASS TOP",
      "Extra PULL_MODERN_R_CHROME TOP",
      "Extra PULL_MODERN_R_NICKEL TOP",
      "Extra PULL_MODERN_L_BLACK TOP",
      "Extra PULL_MODERN_L_BRASS TOP",
      "Extra PULL_MODERN_L_CHROME TOP",
      "Extra PULL_MODERN_L_NICKEL TOP",

    ],
    drawerHardware: [
      ...extraKnobDR,
      ...extraPullDR,
    ]
  },
  "25.5/25.5W_TOWER": {
    top: [
      "25.5/25.5W_ROD",
      "25.5/25.5W_ROD_BLACK",
      "25.5/25.5W_ROD_BRASS",
      "25.5/25.5W_ROD_CHROME",
      "25.5/25.5W_ROD_NICKEL",
      "25.5/25.5W_SHELF",
      "25.5/25.5W_SHELF_DP14",
      "Extra 25.5/25.5W_SHELF_DP14 1",
      "Extra 25.5/25.5W_SHELF_DP14 2",
      "Extra 25.5/25.5W_SHELF_DP14 3",
      "Extra 25.5/25.5W_SHELF MIDDLE",
      "Extra 25.5/25.5W_SHELF 1",
      "Extra 25.5/25.5W_SHELF 2",
      "Extra 25.5/25.5W_SHELF 3",
      "Extra 25.5/25.5W_ROD 1",
      "Extra 25.5/25.5W_ROD_BLACK 1",
      "Extra 25.5/25.5W_ROD_BRASS 1",
      "Extra 25.5/25.5W_ROD_CHROME 1",
      "Extra 25.5/25.5W_ROD_NICKEL 1",
      "25.5/25.5W_FHD_L",
      "25.5/25.5W_FHD_R",
      "25.5/25.5W_HDO_L",
      "25.5/25.5W_HDO_R",
    ],
    bottom: [
      "25.5/25.5W_ROD",
      "25.5/25.5W_ROD_BLACK",
      "25.5/25.5W_ROD_BRASS",
      "25.5/25.5W_ROD_CHROME",
      "25.5/25.5W_ROD_NICKEL",
      "25.5/25.5W_SHELF",
      "25.5/25.5W_SHELF_DP14",
      "Extra 25.5/25.5W_SHELF_DP14 1",
      "Extra 25.5/25.5W_SHELF_DP14 2",
      "Extra 25.5/25.5W_SHELF 1",
      "Extra 25.5/25.5W_SHELF 2",
      "25.5/25.5W_FHD_L",
      "25.5/25.5W_FHD_R",
      "25.5/25.5W_HDO_L",
      "25.5/25.5W_HDO_R",
    ],
    door: [
      "25.5/25.5W_FHD_L",
      "25.5/25.5W_FHD_R",
      "25.5/25.5W_3QD_L",
      "25.5/25.5W_3QD_R",
      "25.5/25.5W_HDO_L",
      "25.5/25.5W_HDO_R",
    ],
    doorHardware: [
      "PULL_KNOB_R_BLACK",
      "PULL_KNOB_R_BRASS",
      "PULL_KNOB_R_CHROME",
      "PULL_KNOB_R_NICKEL",
      "PULL_KNOB_L_BLACK",
      "PULL_KNOB_L_BRASS",
      "PULL_KNOB_L_CHROME",
      "PULL_KNOB_L_NICKEL",

      "Extra PULL_KNOB_R_BLACK TOP",
      "Extra PULL_KNOB_R_BRASS TOP",
      "Extra PULL_KNOB_R_CHROME TOP",
      "Extra PULL_KNOB_R_NICKEL TOP",
      "Extra PULL_KNOB_L_BLACK TOP",
      "Extra PULL_KNOB_L_BRASS TOP",
      "Extra PULL_KNOB_L_CHROME TOP",
      "Extra PULL_KNOB_L_NICKEL TOP",
      // ],
      // pull: [
      "PULL_MODERN_R_BLACK",
      "PULL_MODERN_R_BRASS",
      "PULL_MODERN_R_CHROME",
      "PULL_MODERN_R_NICKEL",
      "PULL_MODERN_L_BLACK",
      "PULL_MODERN_L_BRASS",
      "PULL_MODERN_L_CHROME",
      "PULL_MODERN_L_NICKEL",

      "Extra PULL_MODERN_R_BLACK TOP",
      "Extra PULL_MODERN_R_BRASS TOP",
      "Extra PULL_MODERN_R_CHROME TOP",
      "Extra PULL_MODERN_R_NICKEL TOP",
      "Extra PULL_MODERN_L_BLACK TOP",
      "Extra PULL_MODERN_L_BRASS TOP",
      "Extra PULL_MODERN_L_CHROME TOP",
      "Extra PULL_MODERN_L_NICKEL TOP",
    ],
  },
  "27/27W_TOWER": {
    top: [
      "27/27W_ROD",
      "27/27W_ROD_BLACK",
      "27/27W_ROD_BRASS",
      "27/27W_ROD_CHROME",
      "27/27W_ROD_NICKEL",
      "27/27W_SHELF",
      "27/27W_SHELF_DP14",
      "Extra 27/27W_SHELF_DP14 1",
      "Extra 27/27W_SHELF_DP14 2",
      "Extra 27/27W_SHELF_DP14 3",
      "Extra 27/27W_SHELF MIDDLE",
      "Extra 27/27W_SHELF 1",
      "Extra 27/27W_SHELF 2",
      "Extra 27/27W_SHELF 3",
      "Extra 27/27W_ROD 1",
      "Extra 27/27W_ROD_BLACK 1",
      "Extra 27/27W_ROD_BRASS 1",
      "Extra 27/27W_ROD_CHROME 1",
      "Extra 27/27W_ROD_NICKEL 1",
      "27/27W_FHD_L",
      "27/27W_FHD_R",
      "27/27W_HDO_L",
      "27/27W_HDO_R",
    ],
    bottom: [
      "27/27W_ROD",
      "27/27W_ROD_BLACK",
      "27/27W_ROD_BRASS",
      "27/27W_ROD_CHROME",
      "27/27W_ROD_NICKEL",
      "27/27W_SHELF",
      "27/27W_SHELF_DP14",
      "Extra 27/27W_SHELF_DP14 1",
      "Extra 27/27W_SHELF_DP14 2",
      "Extra 27/27W_SHELF 1",
      "Extra 27/27W_SHELF 2",
      "27/27W_FHD_L",
      "27/27W_FHD_R",
      "27/27W_HDO_L",
      "27/27W_HDO_R",
    ],
    door: [
      "27/27W_FHD_L",
      "27/27W_FHD_R",
      "27/27W_3QD_L",
      "27/27W_3QD_R",
      "27/27W_HDO_L",
      "27/27W_HDO_R",
    ],
    doorHardware: [
      "PULL_KNOB_R_BLACK",
      "PULL_KNOB_R_BRASS",
      "PULL_KNOB_R_CHROME",
      "PULL_KNOB_R_NICKEL",
      "PULL_KNOB_L_BLACK",
      "PULL_KNOB_L_BRASS",
      "PULL_KNOB_L_CHROME",
      "PULL_KNOB_L_NICKEL",

      "Extra PULL_KNOB_R_BLACK TOP",
      "Extra PULL_KNOB_R_BRASS TOP",
      "Extra PULL_KNOB_R_CHROME TOP",
      "Extra PULL_KNOB_R_NICKEL TOP",
      "Extra PULL_KNOB_L_BLACK TOP",
      "Extra PULL_KNOB_L_BRASS TOP",
      "Extra PULL_KNOB_L_CHROME TOP",
      "Extra PULL_KNOB_L_NICKEL TOP",
      // ],
      // pull: [
      "PULL_MODERN_R_BLACK",
      "PULL_MODERN_R_BRASS",
      "PULL_MODERN_R_CHROME",
      "PULL_MODERN_R_NICKEL",
      "PULL_MODERN_L_BLACK",
      "PULL_MODERN_L_BRASS",
      "PULL_MODERN_L_CHROME",
      "PULL_MODERN_L_NICKEL",

      "Extra PULL_MODERN_R_BLACK TOP",
      "Extra PULL_MODERN_R_BRASS TOP",
      "Extra PULL_MODERN_R_CHROME TOP",
      "Extra PULL_MODERN_R_NICKEL TOP",
      "Extra PULL_MODERN_L_BLACK TOP",
      "Extra PULL_MODERN_L_BRASS TOP",
      "Extra PULL_MODERN_L_CHROME TOP",
      "Extra PULL_MODERN_L_NICKEL TOP",
    ],
  },
  "28.5/28.5W_TOWER": {
    top: [
      "28.5/28.5W_ROD",
      "28.5/28.5W_ROD_BLACK",
      "28.5/28.5W_ROD_BRASS",
      "28.5/28.5W_ROD_CHROME",
      "28.5/28.5W_ROD_NICKEL",
      "28.5/28.5W_SHELF",
      "28.5/28.5W_SHELF_DP14",
      "Extra 28.5/28.5W_SHELF_DP14 1",
      "Extra 28.5/28.5W_SHELF_DP14 2",
      "Extra 28.5/28.5W_SHELF_DP14 3",
      "Extra 28.5/28.5W_SHELF MIDDLE",
      "Extra 28.5/28.5W_SHELF 1",
      "Extra 28.5/28.5W_SHELF 2",
      "Extra 28.5/28.5W_SHELF 3",
      "Extra 28.5/28.5W_ROD 1",
      "Extra 28.5/28.5W_ROD_BLACK 1",
      "Extra 28.5/28.5W_ROD_BRASS 1",
      "Extra 28.5/28.5W_ROD_CHROME 1",
      "Extra 28.5/28.5W_ROD_NICKEL 1",
      "28.5/28.5W_FHD_L",
      "28.5/28.5W_FHD_R",
      "28.5/28.5W_HDO_L",
      "28.5/28.5W_HDO_R",
    ],
    bottom: [
      "28.5/28.5W_ROD",
      "28.5/28.5W_ROD_BLACK",
      "28.5/28.5W_ROD_BRASS",
      "28.5/28.5W_ROD_CHROME",
      "28.5/28.5W_ROD_NICKEL",
      "28.5/28.5W_SHELF",
      "28.5/28.5W_SHELF_DP14",
      "Extra 28.5/28.5W_SHELF_DP14 1",
      "Extra 28.5/28.5W_SHELF_DP14 2",
      "Extra 28.5/28.5W_SHELF 1",
      "Extra 28.5/28.5W_SHELF 2",
      "28.5/28.5W_FHD_L",
      "28.5/28.5W_FHD_R",
      "28.5/28.5W_HDO_L",
      "28.5/28.5W_HDO_R",
    ],
    door: [
      "28.5/28.5W_FHD_L",
      "28.5/28.5W_FHD_R",
      "28.5/28.5W_3QD_L",
      "28.5/28.5W_3QD_R",
      "28.5/28.5W_HDO_L",
      "28.5/28.5W_HDO_R",
    ],
    doorHardware: [
      "PULL_KNOB_R_BLACK",
      "PULL_KNOB_R_BRASS",
      "PULL_KNOB_R_CHROME",
      "PULL_KNOB_R_NICKEL",
      "PULL_KNOB_L_BLACK",
      "PULL_KNOB_L_BRASS",
      "PULL_KNOB_L_CHROME",
      "PULL_KNOB_L_NICKEL",

      "Extra PULL_KNOB_R_BLACK TOP",
      "Extra PULL_KNOB_R_BRASS TOP",
      "Extra PULL_KNOB_R_CHROME TOP",
      "Extra PULL_KNOB_R_NICKEL TOP",
      "Extra PULL_KNOB_L_BLACK TOP",
      "Extra PULL_KNOB_L_BRASS TOP",
      "Extra PULL_KNOB_L_CHROME TOP",
      "Extra PULL_KNOB_L_NICKEL TOP",
      // ],
      // pull: [
      "PULL_MODERN_R_BLACK",
      "PULL_MODERN_R_BRASS",
      "PULL_MODERN_R_CHROME",
      "PULL_MODERN_R_NICKEL",
      "PULL_MODERN_L_BLACK",
      "PULL_MODERN_L_BRASS",
      "PULL_MODERN_L_CHROME",
      "PULL_MODERN_L_NICKEL",

      "Extra PULL_MODERN_R_BLACK TOP",
      "Extra PULL_MODERN_R_BRASS TOP",
      "Extra PULL_MODERN_R_CHROME TOP",
      "Extra PULL_MODERN_R_NICKEL TOP",
      "Extra PULL_MODERN_L_BLACK TOP",
      "Extra PULL_MODERN_L_BRASS TOP",
      "Extra PULL_MODERN_L_CHROME TOP",
      "Extra PULL_MODERN_L_NICKEL TOP",
    ],
  },
  "30/30W_TOWER": {
    top: [
      "30/30W_ROD",
      "30/30W_ROD_BLACK",
      "30/30W_ROD_BRASS",
      "30/30W_ROD_CHROME",
      "30/30W_ROD_NICKEL",
      "30/30W_SHELF",
      "30/30W_SHELF_DP14",
      "Extra 30/30W_SHELF_DP14 1",
      "Extra 30/30W_SHELF_DP14 2",
      "Extra 30/30W_SHELF_DP14 3",
      "30/30W_SS",
      "30/30W_SS_DP14",
      "30/30W_DR",
      "Extra 30/30W_DR 1",
      "Extra 30/30W_DR 2",
      "Extra 30/30W_DR 3",
      "Extra 30/30W_DR 4",
      "30/30W_CUBBY",
      "30/30W_CUBBY_DP14",
      "Extra 30/30W_SHELF MIDDLE",
      "Extra 30/30W_SHELF 1",
      "Extra 30/30W_SHELF 2",
      "Extra 30/30W_SHELF 3",
      "Extra 30/30W_ROD 1",
      "Extra 30/30W_ROD_BLACK 1",
      "Extra 30/30W_ROD_BRASS 1",
      "Extra 30/30W_ROD_CHROME 1",
      "Extra 30/30W_ROD_NICKEL 1",
      "Extra 30/30W_SS 1",
      "Extra 30/30W_SS 2",
      "Extra 30/30W_SS 3",
      "Extra 30/30W_SS 4",
      "Extra 30/30W_SS_DP14 1",
      "Extra 30/30W_SS_DP14 2",
      "Extra 30/30W_SS_DP14 3",
      "Extra 30/30W_SS_DP14 4",
      "30/30W_FHD_L",
      "30/30W_FHD_R",
      "30/30W_HDO_L",
      "30/30W_HDO_R",
    ],
    bottom: [
      "30/30W_ROD",
      "30/30W_ROD_BLACK",
      "30/30W_ROD_BRASS",
      "30/30W_ROD_CHROME",
      "30/30W_ROD_NICKEL",
      "30/30W_SHELF",
      "30/30W_SHELF_DP14",
      "Extra 30/30W_SHELF_DP14 1",
      "Extra 30/30W_SHELF_DP14 2",
      "30/30W_SS",
      "30/30W_SS_DP14",
      "30/30W_DR",
      "Extra 30/30W_DR 1",
      "Extra 30/30W_DR 2",
      "Extra 30/30W_DR 3",
      "Extra 30/30W_DR 4",
      "30/30W_CUBBY",
      "30/30W_CUBBY_DP14",
      "Extra 30/30W_SS 1",
      "Extra 30/30W_SS 2",
      "Extra 30/30W_SS 3",
      "Extra 30/30W_SS 4",
      "Extra 30/30W_SS_DP14 1",
      "Extra 30/30W_SS_DP14 2",
      "Extra 30/30W_SS_DP14 3",
      "Extra 30/30W_SS_DP14 4",
      "Extra 30/30W_SHELF 1",
      "Extra 30/30W_SHELF 2",
      "30/30W_DR_S",
      "Extra 30/30W_DR_S 1",
      "Extra 30/30W_DR_S 2",
      "30/30W_FHD_L",
      "30/30W_FHD_R",
      "30/30W_HDO_L",
      "30/30W_HDO_R",
    ],
    door: [
      "30/30W_FHD_L",
      "30/30W_FHD_R",
      "30/30W_3QD_L",
      "30/30W_3QD_R",
      "30/30W_HDO_L",
      "30/30W_HDO_R",
    ],
    doorHardware: [
      "PULL_KNOB_R_BLACK",
      "PULL_KNOB_R_BRASS",
      "PULL_KNOB_R_CHROME",
      "PULL_KNOB_R_NICKEL",
      "PULL_KNOB_L_BLACK",
      "PULL_KNOB_L_BRASS",
      "PULL_KNOB_L_CHROME",
      "PULL_KNOB_L_NICKEL",

      "Extra PULL_KNOB_R_BLACK TOP",
      "Extra PULL_KNOB_R_BRASS TOP",
      "Extra PULL_KNOB_R_CHROME TOP",
      "Extra PULL_KNOB_R_NICKEL TOP",
      "Extra PULL_KNOB_L_BLACK TOP",
      "Extra PULL_KNOB_L_BRASS TOP",
      "Extra PULL_KNOB_L_CHROME TOP",
      "Extra PULL_KNOB_L_NICKEL TOP",

      //   ...extraKnobDR,
      // ],
      // pull: [
      "PULL_MODERN_R_BLACK",
      "PULL_MODERN_R_BRASS",
      "PULL_MODERN_R_CHROME",
      "PULL_MODERN_R_NICKEL",
      "PULL_MODERN_L_BLACK",
      "PULL_MODERN_L_BRASS",
      "PULL_MODERN_L_CHROME",
      "PULL_MODERN_L_NICKEL",

      "Extra PULL_MODERN_R_BLACK TOP",
      "Extra PULL_MODERN_R_BRASS TOP",
      "Extra PULL_MODERN_R_CHROME TOP",
      "Extra PULL_MODERN_R_NICKEL TOP",
      "Extra PULL_MODERN_L_BLACK TOP",
      "Extra PULL_MODERN_L_BRASS TOP",
      "Extra PULL_MODERN_L_CHROME TOP",
      "Extra PULL_MODERN_L_NICKEL TOP",

    ],
    drawerHardware: [
      ...extraKnobDR,
      ...extraPullDR,
    ]
  },
  "31.5/31.5W_TOWER": {
    top: [
      "31.5/31.5W_ROD",
      "31.5/31.5W_ROD_BLACK",
      "31.5/31.5W_ROD_BRASS",
      "31.5/31.5W_ROD_CHROME",
      "31.5/31.5W_ROD_NICKEL",
      "31.5/31.5W_SHELF",
      "31.5/31.5W_SHELF_DP14",
      "Extra 31.5/31.5W_SHELF_DP14 1",
      "Extra 31.5/31.5W_SHELF_DP14 2",
      "Extra 31.5/31.5W_SHELF_DP14 3",
      "Extra 31.5/31.5W_SHELF MIDDLE",
      "Extra 31.5/31.5W_SHELF 1",
      "Extra 31.5/31.5W_SHELF 2",
      "Extra 31.5/31.5W_SHELF 3",
      "Extra 31.5/31.5W_ROD 1",
      "Extra 31.5/31.5W_ROD_BLACK 1",
      "Extra 31.5/31.5W_ROD_BRASS 1",
      "Extra 31.5/31.5W_ROD_CHROME 1",
      "Extra 31.5/31.5W_ROD_NICKEL 1",
      "31.5/31.5W_FHD_L",
      "31.5/31.5W_FHD_R",
      "31.5/31.5W_HDO_L",
      "31.5/31.5W_HDO_R",
    ],
    bottom: [
      "31.5/31.5W_ROD",
      "31.5/31.5W_ROD_BLACK",
      "31.5/31.5W_ROD_BRASS",
      "31.5/31.5W_ROD_CHROME",
      "31.5/31.5W_ROD_NICKEL",
      "31.5/31.5W_SHELF",
      "31.5/31.5W_SHELF_DP14",
      "Extra 31.5/31.5W_SHELF_DP14 1",
      "Extra 31.5/31.5W_SHELF_DP14 2",
      "Extra 31.5/31.5W_SHELF 1",
      "Extra 31.5/31.5W_SHELF 2",
      "31.5/31.5W_FHD_L",
      "31.5/31.5W_FHD_R",
      "31.5/31.5W_HDO_L",
      "31.5/31.5W_HDO_R",
    ],
    door: [
      "31.5/31.5W_FHD_L",
      "31.5/31.5W_FHD_R",
      "31.5/31.5W_3QD_L",
      "31.5/31.5W_3QD_R",
      "31.5/31.5W_HDO_L",
      "31.5/31.5W_HDO_R",
    ],
    doorHardware: [
      "PULL_KNOB_R_BLACK",
      "PULL_KNOB_R_BRASS",
      "PULL_KNOB_R_CHROME",
      "PULL_KNOB_R_NICKEL",
      "PULL_KNOB_L_BLACK",
      "PULL_KNOB_L_BRASS",
      "PULL_KNOB_L_CHROME",
      "PULL_KNOB_L_NICKEL",

      "Extra PULL_KNOB_R_BLACK TOP",
      "Extra PULL_KNOB_R_BRASS TOP",
      "Extra PULL_KNOB_R_CHROME TOP",
      "Extra PULL_KNOB_R_NICKEL TOP",
      "Extra PULL_KNOB_L_BLACK TOP",
      "Extra PULL_KNOB_L_BRASS TOP",
      "Extra PULL_KNOB_L_CHROME TOP",
      "Extra PULL_KNOB_L_NICKEL TOP",
      // ],
      // pull: [
      "PULL_MODERN_R_BLACK",
      "PULL_MODERN_R_BRASS",
      "PULL_MODERN_R_CHROME",
      "PULL_MODERN_R_NICKEL",
      "PULL_MODERN_L_BLACK",
      "PULL_MODERN_L_BRASS",
      "PULL_MODERN_L_CHROME",
      "PULL_MODERN_L_NICKEL",

      "Extra PULL_MODERN_R_BLACK TOP",
      "Extra PULL_MODERN_R_BRASS TOP",
      "Extra PULL_MODERN_R_CHROME TOP",
      "Extra PULL_MODERN_R_NICKEL TOP",
      "Extra PULL_MODERN_L_BLACK TOP",
      "Extra PULL_MODERN_L_BRASS TOP",
      "Extra PULL_MODERN_L_CHROME TOP",
      "Extra PULL_MODERN_L_NICKEL TOP",
    ],
  },
  "33/33W_TOWER": {
    top: [
      "33/33W_ROD",
      "33/33W_ROD_BLACK",
      "33/33W_ROD_BRASS",
      "33/33W_ROD_CHROME",
      "33/33W_ROD_NICKEL",
      "33/33W_SHELF",
      "33/33W_SHELF_DP14",
      "Extra 33/33W_SHELF_DP14 1",
      "Extra 33/33W_SHELF_DP14 2",
      "Extra 33/33W_SHELF_DP14 3",
      "Extra 33/33W_SHELF MIDDLE",
      "Extra 33/33W_SHELF 1",
      "Extra 33/33W_SHELF 2",
      "Extra 33/33W_SHELF 3",
      "Extra 33/33W_ROD 1",
      "Extra 33/33W_ROD_BLACK 1",
      "Extra 33/33W_ROD_BRASS 1",
      "Extra 33/33W_ROD_CHROME 1",
      "Extra 33/33W_ROD_NICKEL 1",
      "33/33W_FHD_L",
      "33/33W_FHD_R",
      "33/33W_HDO_L",
      "33/33W_HDO_R",

      "Extra PULL_KNOB_R_BLACK TOP",
      "Extra PULL_KNOB_R_BRASS TOP",
      "Extra PULL_KNOB_R_CHROME TOP",
      "Extra PULL_KNOB_R_NICKEL TOP",
      "Extra PULL_KNOB_L_BLACK TOP",
      "Extra PULL_KNOB_L_BRASS TOP",
      "Extra PULL_KNOB_L_CHROME TOP",
      "Extra PULL_KNOB_L_NICKEL TOP",
    ],
    bottom: [
      "33/33W_ROD",
      "33/33W_ROD_BLACK",
      "33/33W_ROD_BRASS",
      "33/33W_ROD_CHROME",
      "33/33W_ROD_NICKEL",
      "33/33W_SHELF",
      "33/33W_SHELF_DP14",
      "Extra 33/33W_SHELF_DP14 1",
      "Extra 33/33W_SHELF_DP14 2",
      "Extra 33/33W_SHELF 1",
      "Extra 33/33W_SHELF 2",
      "33/33W_FHD_L",
      "33/33W_FHD_R",
      "33/33W_HDO_L",
      "33/33W_HDO_R",
    ],
    door: [
      "33/33W_FHD_L",
      "33/33W_FHD_R",
      "33/33W_3QD_L",
      "33/33W_3QD_R",
      "33/33W_HDO_L",
      "33/33W_HDO_R",
    ],
    doorHardware: [
      "PULL_KNOB_R_BLACK",
      "PULL_KNOB_R_BRASS",
      "PULL_KNOB_R_CHROME",
      "PULL_KNOB_R_NICKEL",
      "PULL_KNOB_L_BLACK",
      "PULL_KNOB_L_BRASS",
      "PULL_KNOB_L_CHROME",
      "PULL_KNOB_L_NICKEL",

      "Extra PULL_KNOB_R_BLACK TOP",
      "Extra PULL_KNOB_R_BRASS TOP",
      "Extra PULL_KNOB_R_CHROME TOP",
      "Extra PULL_KNOB_R_NICKEL TOP",
      "Extra PULL_KNOB_L_BLACK TOP",
      "Extra PULL_KNOB_L_BRASS TOP",
      "Extra PULL_KNOB_L_CHROME TOP",
      "Extra PULL_KNOB_L_NICKEL TOP",
      // ],
      // pull: [
      "PULL_MODERN_R_BLACK",
      "PULL_MODERN_R_BRASS",
      "PULL_MODERN_R_CHROME",
      "PULL_MODERN_R_NICKEL",
      "PULL_MODERN_L_BLACK",
      "PULL_MODERN_L_BRASS",
      "PULL_MODERN_L_CHROME",
      "PULL_MODERN_L_NICKEL",

      "Extra PULL_MODERN_R_BLACK TOP",
      "Extra PULL_MODERN_R_BRASS TOP",
      "Extra PULL_MODERN_R_CHROME TOP",
      "Extra PULL_MODERN_R_NICKEL TOP",
      "Extra PULL_MODERN_L_BLACK TOP",
      "Extra PULL_MODERN_L_BRASS TOP",
      "Extra PULL_MODERN_L_CHROME TOP",
      "Extra PULL_MODERN_L_NICKEL TOP",
    ],
  },
  "34.5/34.5W_TOWER": {
    top: [
      "34.5/34.5W_ROD",
      "34.5/34.5W_ROD_BLACK",
      "34.5/34.5W_ROD_BRASS",
      "34.5/34.5W_ROD_CHROME",
      "34.5/34.5W_ROD_NICKEL",
      "34.5/34.5W_SHELF",
      "34.5/34.5W_SHELF_DP14",
      "Extra 34.5/34.5W_SHELF_DP14 1",
      "Extra 34.5/34.5W_SHELF_DP14 2",
      "Extra 34.5/34.5W_SHELF_DP14 3",
      "Extra 34.5/34.5W_SHELF MIDDLE",
      "Extra 34.5/34.5W_SHELF 1",
      "Extra 34.5/34.5W_SHELF 2",
      "Extra 34.5/34.5W_SHELF 3",
      "Extra 34.5/34.5W_ROD 1",
      "Extra 34.5/34.5W_ROD_BLACK 1",
      "Extra 34.5/34.5W_ROD_BRASS 1",
      "Extra 34.5/34.5W_ROD_CHROME 1",
      "Extra 34.5/34.5W_ROD_NICKEL 1",
      "34.5/34.5W_FHD_L",
      "34.5/34.5W_FHD_R",
      "34.5/34.5W_HDO_L",
      "34.5/34.5W_HDO_R",
      "34.5/34.5W_HDP_L",
      "34.5/34.5W_HDP_R",
    ],
    bottom: [
      "34.5/34.5W_ROD",
      "34.5/34.5W_ROD_BLACK",
      "34.5/34.5W_ROD_BRASS",
      "34.5/34.5W_ROD_CHROME",
      "34.5/34.5W_ROD_NICKEL",
      "34.5/34.5W_SHELF",
      "34.5/34.5W_SHELF_DP14",
      "Extra 34.5/34.5W_SHELF_DP14 1",
      "Extra 34.5/34.5W_SHELF_DP14 2",
      "Extra 34.5/34.5W_SHELF 1",
      "Extra 34.5/34.5W_SHELF 2",
      "34.5/34.5W_FHD_L",
      "34.5/34.5W_FHD_R",
      "34.5/34.5W_HDO_L",
      "34.5/34.5W_HDO_R",
      "34.5/34.5W_HDP_L",
      "34.5/34.5W_HDP_R",
    ],
    door: [
      "34.5/34.5W_FHD_R",
      "34.5/34.5W_FHD_L",
      "34.5/34.5W_3QD_R",
      "34.5/34.5W_3QD_L",
      "34.5/34.5W_HDO_R",
      "34.5/34.5W_HDO_L",
    ],
    doorHardware: [
      "PULL_KNOB_R_BLACK",
      "PULL_KNOB_R_BRASS",
      "PULL_KNOB_R_CHROME",
      "PULL_KNOB_R_NICKEL",
      "PULL_KNOB_L_BLACK",
      "PULL_KNOB_L_BRASS",
      "PULL_KNOB_L_CHROME",
      "PULL_KNOB_L_NICKEL",

      "Extra PULL_KNOB_R_BLACK TOP",
      "Extra PULL_KNOB_R_BRASS TOP",
      "Extra PULL_KNOB_R_CHROME TOP",
      "Extra PULL_KNOB_R_NICKEL TOP",
      "Extra PULL_KNOB_L_BLACK TOP",
      "Extra PULL_KNOB_L_BRASS TOP",
      "Extra PULL_KNOB_L_CHROME TOP",
      "Extra PULL_KNOB_L_NICKEL TOP",
      // ],
      // pull: [
      "PULL_MODERN_R_BLACK",
      "PULL_MODERN_R_BRASS",
      "PULL_MODERN_R_CHROME",
      "PULL_MODERN_R_NICKEL",
      "PULL_MODERN_L_BLACK",
      "PULL_MODERN_L_BRASS",
      "PULL_MODERN_L_CHROME",
      "PULL_MODERN_L_NICKEL",

      "Extra PULL_MODERN_R_BLACK TOP",
      "Extra PULL_MODERN_R_BRASS TOP",
      "Extra PULL_MODERN_R_CHROME TOP",
      "Extra PULL_MODERN_R_NICKEL TOP",
      "Extra PULL_MODERN_L_BLACK TOP",
      "Extra PULL_MODERN_L_BRASS TOP",
      "Extra PULL_MODERN_L_CHROME TOP",
      "Extra PULL_MODERN_L_NICKEL TOP",
    ],
  },
  "36/36W_TOWER": {
    top: [
      "36/36W_ROD",
      "36/36W_ROD_BLACK",
      "36/36W_ROD_BRASS",
      "36/36W_ROD_CHROME",
      "36/36W_ROD_NICKEL",
      "36/36W_SHELF",
      "36/36W_SHELF_DP14",
      "Extra 36/36W_SHELF_DP14 1",
      "Extra 36/36W_SHELF_DP14 2",
      "Extra 36/36W_SHELF_DP14 3",
      "Extra 36/36W_SHELF MIDDLE",
      "Extra 36/36W_SHELF 1",
      "Extra 36/36W_SHELF 2",
      "Extra 36/36W_SHELF 3",
      "Extra 36/36W_ROD 1",
      "Extra 36/36W_ROD_BLACK 1",
      "Extra 36/36W_ROD_BRASS 1",
      "Extra 36/36W_ROD_CHROME 1",
      "Extra 36/36W_ROD_NICKEL 1",
      "36/36W_FHD_L",
      "36/36W_FHD_R",
      "36/36W_HDO_L",
      "36/36W_HDO_R",
    ],
    bottom: [
      "36/36W_ROD",
      "36/36W_ROD_BLACK",
      "36/36W_ROD_BRASS",
      "36/36W_ROD_CHROME",
      "36/36W_ROD_NICKEL",
      "36/36W_SHELF",
      "36/36W_SHELF_DP14",
      "Extra 36/36W_SHELF_DP14 1",
      "Extra 36/36W_SHELF_DP14 2",
      "Extra 36/36W_SHELF 1",
      "Extra 36/36W_SHELF 2",
      "36/36W_FHD_L",
      "36/36W_FHD_R",
      "36/36W_HDO_L",
      "36/36W_HDO_R",
    ],
    door: [
      "36/36W_FHD_L",
      "36/36W_FHD_R",
      "36/36W_3QD_L",
      "36/36W_3QD_R",
      "36/36W_HDO_L",
      "36/36W_HDO_R",
    ],
    doorHardware: [
      "PULL_KNOB_R_BLACK",
      "PULL_KNOB_R_BRASS",
      "PULL_KNOB_R_CHROME",
      "PULL_KNOB_R_NICKEL",
      "PULL_KNOB_L_BLACK",
      "PULL_KNOB_L_BRASS",
      "PULL_KNOB_L_CHROME",
      "PULL_KNOB_L_NICKEL",

      "Extra PULL_KNOB_R_BLACK TOP",
      "Extra PULL_KNOB_R_BRASS TOP",
      "Extra PULL_KNOB_R_CHROME TOP",
      "Extra PULL_KNOB_R_NICKEL TOP",
      "Extra PULL_KNOB_L_BLACK TOP",
      "Extra PULL_KNOB_L_BRASS TOP",
      "Extra PULL_KNOB_L_CHROME TOP",
      "Extra PULL_KNOB_L_NICKEL TOP",
      // ],
      // pull: [
      "PULL_MODERN_R_BLACK",
      "PULL_MODERN_R_BRASS",
      "PULL_MODERN_R_CHROME",
      "PULL_MODERN_R_NICKEL",
      "PULL_MODERN_L_BLACK",
      "PULL_MODERN_L_BRASS",
      "PULL_MODERN_L_CHROME",
      "PULL_MODERN_L_NICKEL",

      "Extra PULL_MODERN_R_BLACK TOP",
      "Extra PULL_MODERN_R_BRASS TOP",
      "Extra PULL_MODERN_R_CHROME TOP",
      "Extra PULL_MODERN_R_NICKEL TOP",
      "Extra PULL_MODERN_L_BLACK TOP",
      "Extra PULL_MODERN_L_BRASS TOP",
      "Extra PULL_MODERN_L_CHROME TOP",
      "Extra PULL_MODERN_L_NICKEL TOP",
    ],
  },
};
